

<template>
<div id="daftar-pelaporan" class="content content--borderless">
  <div class="content__header">
    <div class="content__main-header">
      <div class="content__title">
        <div class="content__title__name">Daftar Pelaporan <span class="text-primary ml-1">Metadata Statistik</span></div>
        <div class="content__title__description">Daftar semua pelaporan metadata statistik kegiatan yang telah diinput. Klik icon mata untuk melihat detail MS-Kegiatan, MS-Variabel dan MS-Indikator</div>
      </div>
      <div class="ml-auto d-flex">
        

        <b-dropdown id="dropdown-dropup" text="Drop-Up"  class="m-2" toggle-class="button px-2 button--sm button--outlined text-nowrap">
          <template #button-content>
              <VueFeather type="clock" size="14" stroke-width="2" style="display:nlock"></VueFeather> &nbsp; Periode: <span class="text-bold pl-1">{{submissionPeriod}}</span>
          </template>
          <b-dropdown-item  
            v-for="(period , index) in options.submissionPeriod" :key="index" 
            :active="submissionPeriod == period" 
            @click="submissionPeriod = period; getSummaryMetadata();" 
          >
              {{period}}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
  <div class="content__body mt-3 pb-5 form form--sm">
    <div class="table-search">
      <b-input-group>
        <b-input-group-prepend is-text class="bg-none">
          <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
        </b-input-group-prepend>
        <b-form-input 
          type="search"
          debounce="500"
          v-model="filter.name" 
          placeholder="Cari nama kegiatan . . ." 
          class="border-left-0"></b-form-input>
      </b-input-group>
      
      <button type="button" class="button" variant="primary" size="sm" @click="showModalFilter">
        <VueFeather type="filter" size="13" class="button__icon"></VueFeather>
        Filter <span class="button__count" v-if="filterCount>0">{{filterCount}}</span>
      </button>
    </div>
    <div class="table-filter" v-if="filterCount>0" >
        <div class="tags" >
          <div class="tag tag--quinary" v-if="tagsFilter.statisticType">
            <div class="tag__field">Jenis Statistik</div>
            <div class="tag__value">{{options.statisticType.find(x=>x.value == tagsFilter.statisticType).text}}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.statisticType = null;
              getSummaryMetadata()
            }">x</div>
          </div>

          <div class="tag tag--secondary" v-if="tagsFilter.status">
            <div class="tag__field">Status</div>
            <div class="tag__value">{{options.status.find(x=>x.id == tagsFilter.status).label}}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.status = null;
              getSummaryMetadata()
            }">x</div>
          </div>
        
          <div class="tag tag--quaternary" v-if="tagsFilter.requester"> 
            <div class="tag__field">Pengusul</div>
            <div class="tag__value">{{options.requester.find(x=>x.id == tagsFilter.requester).label}}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.requester = null;
              getSummaryMetadata();
            }">x</div>
          </div>
          <div class="tag tag--quaternary" v-if="tagsFilter.approver && tab.index!=1">
            <div class="tag__field">Pemeriksa</div>
            <div class="tag__value">{{options.approver.find(x=>x.id == tagsFilter.approver).label}}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.approver = null;
              getSummaryMetadata();
            }">x</div>
          </div>

          <div class="tag tag--primary" v-if="tagsFilter.provinceCode">
            <div class="tag__field">Provinsi</div>
            <div class="tag__value">{{options.masterProvince.find(x=>x.code == tagsFilter.provinceCode).name}}</div>
            <div class="tag__remove" 
              v-if="role.isPembinaDataPusat([this.appData.current_role]) && filter.city == null" 
              v-on:click="()=>{
                filter.provinceCode = null;
                getSummaryMetadata();
              }"
            >x</div>
          </div>
          <div class="tag tag--primary" v-if="tagsFilter.city">
            <div class="tag__field">Kabupaten/Kota</div>
            <div class="tag__value">{{tagsFilter.city.name}}</div>
            <div class="tag__remove" v-if="role.isPembinaDataPusat([this.appData.current_role])" v-on:click="()=>{
              filter.city = null;
              getSummaryMetadata();
            }">x</div>
          </div>

          <div class="tag tag--senary" v-if="tagsFilter.produsenData">
            <div class="tag__field">Pengusul</div>
            <div class="tag__value">{{tagsFilter.produsenData.name}}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.produsenData = null;
              getSummaryMetadata();
            }">x</div>
          </div>
          <div class="tag tag--tertiary" v-if="tagsFilter.walidata">
            <div class="tag__field">Walidata</div>
            <div class="tag__value">{{tagsFilter.walidata.name}}</div>
            <div class="tag__remove" v-on:click="()=>{
              filter.walidata = null;
              getSummaryMetadata();
            }">x</div>
          </div>
        </div>
      </div>
    <div class="table-wrapper " :style="filterCount==0? 'margin-top:15px':''">
      <b-table
        show-empty
        class="table--light"
        :items="dataMetadataStatistikKegiatan"
        :fields="fieldsMetadata"
      >
        <template #cell(no)="data"> {{10 * (currentPageMetadataStatistikKegiatan - 1) + data.index + 1}}.</template>
        <template #cell(created_at)="data">{{ data.item.created_at | formatDate }} </template>
        
        <template #cell(statistic_type)="data">
          {{data.value == 'STATISTIK_DASAR' ? 'Statistik Dasar' : (data.value == 'STATISTIK_SEKTORAL' ? 'Statistik Sektoral': 'Statistik Khusus')}}
        </template>
        <template #cell(status)="data">
          <span v-html="getBadge(data.item.status)"></span>
        </template>
        <template #cell(tahun)="data">
          {{data.item.data.tahun}}
        </template>
        <template #cell(created_by)="data">
          <div>{{data.item.requester_details ? data.item.requester_details.name : data.item.requested_by}}</div>
          <div v-if="data.item.requester_details && data.item.requester_details.organization && data.item.requester_details.organization.id != data.item.produsen_data_id" class="text-10 text-600">
            {{data.item.requester_details.organization.name}}
          </div>
        </template>
        <template #cell(approved_by)="data">
          {{data.item.approver_details ? data.item.approver_details.name : data.item.approved_by ? data.item.approved_by : '-' }}
        </template>
        <template #cell(aksi)="data">
          <div class="d-flex justify-content-center align-items-center">
            <b-link  
              class="button button--action button--action--view " 
              :to="'/metadata/pemeriksaan/kegiatan/'+data.item.id"
              :disabled="approvalDisabled(data.item)"
              :title="approvalTooltip(data.item)" 
              v-b-tooltip.hover
            >
              <VueFeather type="edit-3" size="14"></VueFeather>
            </b-link>
            <b-link class="button button--action button--action--view " v-b-tooltip.hover title="Lihat detail" :to="'/metadata/view-kegiatan/'+data.item.id">
              <VueFeather type="eye" size="14"></VueFeather>
            </b-link>

            <b-dropdown id="dropdown-right" dropup  right text="Right align" toggle-class="button button--action button--action--edit" no-caret>
              <template #button-content>
                <VueFeather type="download" size="14"></VueFeather>
              </template>
              <b-dropdown-item @click="download(data.item, 'excel')">Excel</b-dropdown-item>
              <b-dropdown-item @click="download(data.item, 'pdf')">Pdf</b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #empty>
          <div class="table__empty">
            <div v-if="isLoading">
              <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
            <div v-else>
              <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                Tidak ada data yang tersedia
            </div>
          </div>
        </template> 
      </b-table>
      <div class="pagination-wrapper">
        <b-pagination
          class="mt-3 "
          align="center"
          v-model="currentPageMetadataStatistikKegiatan"
          :total-rows="rowsMetadataStatistikKegiatan"
          :per-page="perPage"
        ></b-pagination>
        <div class="pagination__goto ml-auto">Go to Page &nbsp;&nbsp;
          <b-form-input type="number" debounce="500" size="sm" v-model="goto"></b-form-input>
        </div>
      </div>
    </div>

    <div ref="export" class="export">
      <table id="export-kegiatan" >
        <tbody v-if="data">
          <tr>
            <td colspan="3">Judul Kegiatan</td>
            <td colspan="3">{{ capitalize(data.judul_kegiatan)}}</td>
          </tr>
          <tr>
            <td colspan="3">Tahun</td>
            <td colspan="3">{{ data.tahun }}</td>
          </tr>
          <tr>
            <td colspan="3">Jenis Statistik</td>
            <td colspan="3">{{ capitalize(data.jenis_statistik) }}</td>
          </tr>
          <tr>
            <td colspan="3">Cara Pengumpulan Data</td>
            <td colspan="3">
              {{ capitalize(data.cara_pengumpulan_data) }}
            </td>
          </tr>
          <tr>
            <td colspan="3">Sektor Kegiatan</td>
            <td colspan="3">
              {{ capitalize(data.sektor_kegiatan) }}
            </td>
          </tr>
          <tr>
            <td colspan="3">Apakah mendapatkan rekomendasi kegiatan statistik dari BPS?</td>
            <td colspan="3">
              {{ capitalize(data.identitas_rekomendasi ? 'Ya' : 'Tidak') }}
            </td>
          </tr>
          <tr>
            <td colspan="3">Identitas Rekomendasi:</td>
            <td colspan="3">
              {{ data.identitas_rekomendasi ? data.identitas_rekomendasi : '-' }}
            </td>
          </tr>

          <!-- blok_i -->
          <tr>
            <th colspan="6" class="section">I. Penyelenggara</th>
          </tr>
          <tr>
            <td style="width: 38px">1.1</td>
            <td colspan="2">Instansi Penyelenggara</td>
            <td colspan="3">
              {{ capitalize(data.blok_i.instansi_penyelanggara) }}
            </td>
          </tr>
          <tr>
            <td>1.2</td>
            <td colspan="2">Alamat</td>
            <td colspan="3">
              {{ capitalize(data.blok_i.alamat_instansi_penyelenggara.alamat) }}
            </td>
          </tr>
          <tr>
            <td>1.3</td>
            <td colspan="2">Telepon</td>
            <td colspan="3">{{ capitalize(data.blok_i.alamat_instansi_penyelenggara.telepon) }}</td>
          </tr>
          <tr>
            <td>1.4</td>
            <td colspan="2">Faksimile</td>
            <td colspan="3">{{ capitalize(data.blok_i.alamat_instansi_penyelenggara.faksimile) }}</td>
          </tr>
          <tr>
            <td>1.5</td>
            <td colspan="2">Email</td>
            <td colspan="3">{{ capitalize(data.blok_i.alamat_instansi_penyelenggara.email) }}</td>
          </tr>
          <!-- blok_ii -->
          <tr>
            <th colspan="6" class="section">II. Penanggung Jawab</th>
          </tr>
          <tr>
            <td rowspan="3">2.1</td>
            <td colspan="5" style="font-weight: 600">
              Unit Eselon Penanggung Jawab
            </td>
          </tr>
          <tr>
            <td colspan="2">Eselon 1</td>
            <td colspan="3">
              {{ capitalize(data.blok_ii.unit_penanggung_jawab.eselon1) }}
            </td>
          </tr>
          <tr>
            <td colspan="2">Eselon 2</td>
            <td colspan="3">
              {{ capitalize(data.blok_ii.unit_penanggung_jawab.eselon2) }}
            </td>
          </tr>
          <tr>
            <td rowspan="7">2.2</td>
            <td colspan="5" style="font-weight: 600">
              Penanggung Jawab Teknis (setingkat Eselon 3)
            </td>
          </tr>
          <tr>
            <td colspan="2">Nama</td>
            <td colspan="3">
              {{ capitalize(data.blok_ii.penanggung_jawab_teknis.nama) }}
            </td>
          </tr>
          <tr>
            <td colspan="2">Jabatan</td>
            <td colspan="3">
              {{ capitalize(data.blok_ii.penanggung_jawab_teknis.jabatan) }}
            </td>
          </tr>
          <tr>
            <td colspan="2">Alamat</td>
            <td colspan="3">
              {{ capitalize(data.blok_ii.penanggung_jawab_teknis.alamat) }}
            </td>
          </tr>
          <tr>
            <td colspan="2">Telepon</td>
            <td colspan="3">
              {{ capitalize(data.blok_ii.penanggung_jawab_teknis.telepon) }}
            </td>
          </tr>
          <tr>
            <td colspan="2">Faksimile</td>
            <td colspan="3">
              {{ capitalize(data.blok_ii.penanggung_jawab_teknis.email) }}
            </td>
          </tr>
          <tr>
            <td colspan="2">Email</td>
            <td colspan="3">
              {{ capitalize(data.blok_ii.penanggung_jawab_teknis.faksimile) }}
            </td>
          </tr>
          <!-- blok_ii -->
          <tr>
            <th colspan="6" class="section">III. Perencanaan dan Persiapan</th>
          </tr>
          <tr>
            <td>3.1</td>
            <td colspan="2">Latar Belakang</td>
            <td colspan="3">
              {{ capitalize(data.blok_iii.latar_belakang_kegiatan) }}
            </td>
          </tr>
          <tr>
            <td>3.2</td>
            <td colspan="2">Tujuan Kegiatan</td>
            <td colspan="3">
              {{ capitalize(data.blok_iii.tujuan_kegiatan) }}
            </td>
          </tr>
          <!-- <tr class="html2pdf__page-break"></tr> -->
          <tr>
            <td rowspan="12">3.3</td>
            <td colspan="5">Rencana Jadwal Kegiatan</td>
          </tr>

          <tr>
            <th colspan="5" class="section section-2">A. Perencanaan</th>
          </tr>
          <tr>
            <td style="white-space: nowrap;width: 28px;padding-left: 0;padding-right: 0;text-align: center;">
              1
            </td>
            <td style="white-space: nowrap">Perencanaan Kegiatan</td>
            <td colspan="4">
              <div v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan" :key="index + 'i'">
                {{item.awal | formatDate}} s/d
                {{item.akhir | formatDate}}
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding-left: 0; padding-right: 0; text-align: center">
              2
            </td>
            <td>Desain</td>
            <td colspan="4">
              <div v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.desain" :key="index + 'i'">
                {{item.awal | formatDate}} s/d
                {{item.akhir | formatDate}}
              </div>
            </td>
          </tr>
          <tr>
            <th colspan="5" class="section section-2">B. Pengumpulan</th>
          </tr>
          <tr>
            <td style="padding-left: 0; padding-right: 0; text-align: center">
              3
            </td>
            <td>Pengumpulan Data</td>
            <td colspan="4">
              <div v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data" :key="index + 'i'">
                {{item.awal | formatDate}} s/d
                {{item.akhir | formatDate}}
              </div>
            </td>
          </tr>

          <tr>
            <th colspan="5" class="section section-2">C. Pemeriksaan</th>
          </tr>
          <tr>
            <td style="padding-left: 0; padding-right: 0; text-align: center">
              4
            </td>
            <td>Pengolahan Data</td>
            <td colspan="4">
              <div v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.pengolahan_data" :key="index + 'i'">
                {{item.awal | formatDate}} s/d
                {{item.akhir | formatDate}}
              </div>
            </td>
          </tr>

          <tr>
            <th colspan="5" class="section section-2">D. Penyebarluasan</th>
          </tr>
          <tr>
            <td style="padding-left: 0; padding-right: 0; text-align: center">
              5
            </td>
            <td>Analisis Data</td>
            <td colspan="4">
              <div v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.analisis" :key="index + 'i'">
                {{item.awal | formatDate}} s/d
                {{item.akhir | formatDate}}
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding-left: 0; padding-right: 0; text-align: center">
              6
            </td>
            <td>Diseminasi Hasil</td>
            <td colspan="4">
              <div v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil" :key="index + 'i'">
                {{item.awal | formatDate}} s/d
                {{item.akhir | formatDate}}
              </div>
            </td>
          </tr>
          <tr>
            <td style="padding-left: 0; padding-right: 0; text-align: center">
              7
            </td>
            <td>Evaluasi</td>
            <td colspan="3">
              <div v-for="(item, index) in data.blok_iii.rencana_jadwal_kegiatan.evaluasi" :key="index + 'i'">
                {{item.awal | formatDate}} s/d
                {{item.akhir | formatDate}}
              </div>
            </td>
          </tr>
          <!-- rincian 3.4 -->

          <tr>
            <td :rowspan=" data.blok_iii.variabel_yang_dikumpulkan.length + 2  ">
              3.4
            </td>
            <td colspan="5">Variabel (Karakteristik) yang Dikumpulkan:</td>
          </tr>

          <tr>
            <th
              class="section section-2"
              style="padding-left: 0; padding-right: 0; text-align: center"
            >
              No
            </th>
            <th class="section section-2" style="width: 180px">
              Nama Variabel <br />
              (Karakteristik)
            </th>
            <th class="section section-2" style="width: 180px">Konsep</th>
            <th class="section section-2">Definisi</th>
            <th class="section section-2" style="width: 170px">
              Referensi Waktu<br />(Periode Enumerasi)
            </th>
          </tr>
          <tr v-for="(item, index) in data.blok_iii.variabel_yang_dikumpulkan" :key="index + 'viii'">
            <td style="padding-left: 0; padding-right: 0; text-align: center">
              {{ index + 1 }}
            </td>
            <td>{{ item.nama }}</td>
            <td>{{ item.konsep }}</td>
            <td>{{ item.definisi }}</td>
            <td>{{ item.referensi_waktu }}</td>
          </tr>
          <!-- blok_vi -->
          <tr>
            <th colspan="6" class="section">IV. Desain Kegiatan</th>
          </tr>
          <tr>
            <td>4.1</td>
            <td colspan="2">Kegiatan ini dilakukan</td>
            <td colspan="3">
              {{ capitalize(data.blok_iv.kegiatan_ini_dilakukan) }}
            </td>
          </tr>
          <tr>
            <td>4.2</td>
            <td colspan="2">Frekuensi Penyelenggaraan</td>
            <td colspan="3">
              {{ capitalize(data.blok_iv.frekuensi_penyelanggara) }}
            </td>
          </tr>
          <tr>
            <td>4.3</td>
            <td colspan="2">Tipe Pengumpulan Data</td>
            <td colspan="3">
              {{ capitalize(data.blok_iv.tipe_pengumpulan_data) }}
            </td>
          </tr>
          <tr>
            <td>4.4</td>
            <td colspan="2">Cakupan Wilayah Pengumpulan Data</td>
            <td colspan="3">
              {{ capitalize(data.blok_iv.cakupan_wilayah_pengumpulan_data) }}
            </td>
          </tr>
          <tr v-if=" data.blok_iv.cakupan_wilayah_pengumpulan_data != 'SELURUH_WILAYAH_INDONESIA'"
          >
            <td :rowspan=" data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data .length + 1">
              4.5
            </td>
            <td colspan="5">Wilayah Kegiatan</td>
          </tr>
          <tr v-if="!data.blok_iv.cakupan_wilayah_pengumpulan_data">
            <th
              class="section section-2"
              style="padding-left: 0; padding-right: 0; text-align: center"
            >
              No
            </th>
            <th class="section section-2" style="width: 180px">Provinsi</th>
            <th colspan="3" class="section section-2" style="width: 180px">
              Kabupaten/Kota
            </th>
          </tr>
          <tr v-for="(item, indexx) in data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data" :key="indexx">
            <td style="padding-left: 0; padding-right: 0; text-align: center">
              {{ indexx + 1 }}
            </td>
            <td>{{ item.nama_provinsi }}</td>
            <td colspan="3">{{ item.nama_kabupaten_kota }}</td>
          </tr>
          <tr>
            <td>4.6</td>
            <td colspan="2">Metode Pengumpulan Data</td>
            <td colspan="3">
              <ul class="list">
                <li v-if="data.blok_iv.metode_pengumpulan_data.wawancara">Wawancara</li>
                <li v-if="data.blok_iv.metode_pengumpulan_data.mengisi_kuesioner_sendiri">Mengisi Kuesioner Sendiri</li>
                <li v-if="data.blok_iv.metode_pengumpulan_data.pengamatan">Pengamatan</li>
                <li v-if="data.blok_iv.metode_pengumpulan_data.pengumpulan_data_sekunder">Pengumpulan Data Sekunder</li>
                <li v-if="data.blok_iv.metode_pengumpulan_data.lainnya">Lainnya : {{data.blok_iv.metode_pengumpulan_data.metode_pengumpulan_lainnya}}</li>
              </ul> 
            </td>
          </tr>
          <tr>
            <td>4.7</td>
            <td colspan="2">Sarana Pengumpulan Data</td>
            <td colspan="3">
              <ul class="list">
                <li  v-if="data.blok_iv.sarana_pengumpulan_data.papi">Paper-assisted Personal Interviewing (PAPI)</li>
                <li  v-if="data.blok_iv.sarana_pengumpulan_data.capi">Computer-assisted Personal Interviewing (CAPI)</li>
                <li  v-if="data.blok_iv.sarana_pengumpulan_data.cati">Computer-assisted Telephones Interviewing (CATI)</li>
                <li  v-if="data.blok_iv.sarana_pengumpulan_data.cawi">Computer Aided Web Interviewing (CAWI)</li>
                <li  v-if="data.blok_iv.sarana_pengumpulan_data.mail">Mail</li>
                <li  v-if="data.blok_iv.sarana_pengumpulan_data.lainnya">Lainnya : {{data.blok_iv.sarana_pengumpulan_data.sarana_pengumpulan_lainnya}}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>4.8</td>
            <td colspan="2">Unit Pengumpulan Data</td>
            <td colspan="3">
              <ul class="list">
                <li v-if="data.blok_iv.unit_pengumpulan_data.individu">Individu</li>
                <li v-if="data.blok_iv.unit_pengumpulan_data.rumah_tangga">Rumah Tangga</li>
                <li v-if="data.blok_iv.unit_pengumpulan_data.usaha_atau_perusahaan">Usaha/Perusahaan</li>
                <li v-if="data.blok_iv.unit_pengumpulan_data.lainnya">Lainnya : {{data.blok_iv.unit_pengumpulan_data.unit_pengumpulan_data_lainnya}}</li>
              </ul>
            </td>
          </tr>
          <!-- blok_v -->
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <th colspan="6" class="section">V. Desain Sampel</th>
          </tr>
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <td>5.1</td>
            <td colspan="2">Jenis Rancangan Sampel</td>
            <td colspan="3">
              {{ capitalize(data.blok_v.jenis_rancangan_sampel) }}
            </td>
          </tr>
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <td>5.2</td>
            <td colspan="2">Metode Pemilihan Sampel Tahap Terakhir</td>
            <td colspan="3">
              {{ capitalize(data.blok_v.metode_pemilihan_sampel_tahap_terakhir) }}
            </td>
          </tr>
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <td>5.3</td>
            <td colspan="2">Metode Sampel Probabilitas yang digunakan</td>
            <td colspan="3">
              {{ capitalize(data.blok_v.metode_yang_digunakan) }}
            </td>
          </tr>
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <td>5.4</td>
            <td colspan="2">Kerangka Sampel Tahap Terakhir</td>
            <td colspan="3">
              {{ capitalize(data.blok_v.kerangka_sampel_tahap_terakhir) }}
            </td>
          </tr>
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <td>5.5</td>
            <td colspan="2">Fraksi Sampel Keseluruhan</td>
            <td colspan="3">
            {{ capitalize(data.blok_v.fraksi_sampel_keseluruhan) }}
            </td>
          </tr>
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <td>5.6</td>
            <td colspan="2">Nilai Perkiraan Sampling Error Variabel Utama</td>
            <td colspan="3">
              {{ capitalize(data.blok_v.nilai_perkiraan_sampling_error_variabel_utama) }}
            </td>
          </tr>
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <td>5.7</td>
            <td colspan="2">Unit Sampel</td>
            <td colspan="3">
              {{ capitalize(data.blok_v.unit_sampel) }}
            </td>
          </tr>
          <tr v-if="data.cara_pengumpulan_data == 'SURVEI'">
            <td>5.8</td>
            <td colspan="2">Unit Observasi</td>
            <td colspan="3">
              {{ capitalize(data.blok_v.unit_observasi) }}
            </td>
          </tr>
          <!-- blok_vi -->
          <tr>
            <th colspan="6" class="section">VI. Pengumpulan Data</th>
          </tr>
          <tr>
            <td>6.1</td>
            <td colspan="2">Apakah Melakukan Uji Coba (Pilot Survey)?</td>
            <td colspan="3">
              {{ data.blok_vi.apakah_melakukan_uji_coba==true? "Ya":"Tidak" }}
            </td>
          </tr>
          <tr>
            <td>6.2</td>
            <td colspan="2">Metode Pemeriksaan Kualitas Pengumpulan Data</td>
            <td colspan="3">
              <ul class="list">
                <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.kunjungan_kembali">Kunjungan Kembali</li>
                <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.supervisi">Supervisi</li>
                <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.taskforce">Task Force</li>
                <li v-if="data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.lainnya">Lainnya: {{data.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.metode_pemeriksaan_kualitas_pengumpulan_data_lainnya}}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>6.3</td>
            <td colspan="2">Apakah Melakukan Penyesuaian Nonrespon?</td>
            <td colspan="3">
              {{ data.blok_vi.apakah_melakukan_penyesuaian_nonrespon==true?"Ya":"Tidak" }}
            </td>
          </tr>
          <tr>
            <td>6.4</td>
            <td colspan="2">Petugas Pengumpulan Data</td>
            <td colspan="3">
            {{ capitalize(data.blok_vi.petugas_pengumpulan_data) }}
            </td>
          </tr>
          <tr>
            <td>6.5</td>
            <td colspan="2">
              Persyaratan Pendidikan Terendah Petugas Pengumpulan Data
            </td>
            <td colspan="3">
              {{ capitalize(data.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data) }}
            </td>
          </tr>

          <tr>
            <td rowspan="3">6.6</td>
            <td colspan="5" style="font-weight: 600">Jumlah Petugas</td>
          </tr>
          <tr>
            <td colspan="2">Supervisor/penyelia/pengawas</td>
            <td colspan="3">
              {{ data.blok_vi.jumlah_petugas_supervisor }}
            </td>
          </tr>
          <tr>
            <td colspan="2">Pengumpul data/enumerator</td>
            <td colspan="3">
              {{ data.blok_vi.jumlah_petugas_enumerator }}
            </td>
          </tr>

          <tr>
            <td>6.7</td>
            <td colspan="2">Apakah Melakukan Pelatihan Petugas?</td>
            <td colspan="3">
              {{data.blok_vii.tahapan_pengolahan_data.editing ? 'Ya':'Tidak'}}
            </td>
          </tr>

          <!-- blok_vii -->
          <tr>
            <th colspan="6" class="section">VII. Pengolahan dan Analisis</th>
          </tr>

          <tr>
            <td rowspan="5">7.1</td>
            <td colspan="5" style="font-weight: 600">Tahapan Pengolahan Data</td>
          </tr>
          <tr>
            <td colspan="2">Penyuntingan <i>(Editing)</i></td>
            <td colspan="3">
            {{data.blok_vii.tahapan_pengolahan_data.editing ? 'Ya':'Tidak'}}
            </td>
          </tr>
          <tr>
            <td colspan="2">Penyandian <i>(Coding)</i></td>
            <td colspan="3">
              {{data.blok_vii.tahapan_pengolahan_data.coding ? 'Ya':'Tidak'}}
            </td>
          </tr>
          <tr>
            <td colspan="2"><i>(Data Entry)</i></td>
            <td colspan="3">
              {{data.blok_vii.tahapan_pengolahan_data.data_entry ? 'Ya':'Tidak'}}
            </td>
          </tr>
          <tr>
            <td colspan="2">Penyahihan <i>(Validasi)</i></td>
            <td colspan="3">
              {{data.blok_vii.tahapan_pengolahan_data.validasi ? 'Ya':'Tidak'}}
            </td>
          </tr>

          <tr>
            <td>7.2</td>
            <td colspan="2">Metode Analisis</td>
            <td colspan="3">
              {{ capitalize(data.blok_vii.metode_analisis) }}
            </td>
          </tr>

          <tr>
            <td>7.3</td>
            <td colspan="2">Unit Analisis</td>
            <td colspan="3">
              <ul class="list">
                <li v-if="data.blok_vii.unit_analsis.individu">Individu</li>
                <li v-if="data.blok_vii.unit_analsis.rumah_tangga">Rumah Tangga</li>
                <li v-if="data.blok_vii.unit_analsis.usaha_atau_perusahaan">Usaha/Perusahaan</li>
                <li v-if="data.blok_vii.unit_analsis.lainnya">Lainnya: {{data.blok_vii.unit_analsis.unit_analisis_lainnya}}</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>7.4</td>
            <td colspan="2">Tingkat Penyajian Hasil Analisis</td>
            <td colspan="3">
              <ul class="list">
                <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.nasional">Nasional</li>
                <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.provinsi">Provinsi</li>
                <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.kabupaten_atau_kota">Kabupaten/Kota</li>
                <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.kecamatan">Kecamatan</li>
                <li v-if="data.blok_vii.tingkat_penyajian_hasil_analisis.lainnya">Lainnya: {{data.blok_vii.tingkat_penyajian_hasil_analisis.tingkat_penyajian_hasil_analisis_lainnya}}</li>
              </ul>
            </td>
          </tr>

          <!-- blok_viii -->
          <tr>
            <th colspan="6" class="section">VIII. Diseminasi Hasil</th>
          </tr>

          <tr>
            <td rowspan="4">8.1</td>
            <td colspan="5" style="font-weight: 600">
              Produk Kegiatan yang Tersedia untuk Umum
            </td>
          </tr>
          <tr>
            <td colspan="2">Tercetak <i>(Hardcopy)</i></td>
            <td colspan="3">
              {{data.blok_viii.ketersediaan_produk_tercetak ? 'Ya':'Tidak'}}
            </td>
          </tr>
          <tr>
            <td colspan="2">Digital <i>(Softcopy)</i></td>
            <td colspan="3">
              {{data.blok_viii.ketersediaan_produk_digital ? 'Ya':'Tidak'}}
            </td>
          </tr>
          <tr>
            <td colspan="2">Data Mikro</td>
            <td colspan="3">
              {{data.blok_viii.ketersediaan_produk_mikrodata ? 'Ya':'Tidak'}}
            </td>
          </tr>

          <tr>
            <td rowspan="4">8.2</td>
            <td colspan="5" style="font-weight: 600">
              Rencana Rilis Produk Kegiatan
            </td>
          </tr>
          <tr>
            <td colspan="2">Tercetak <i>(Hardcopy)</i></td>
            <td colspan="3">
              <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_tercetak" v-bind:key="index">
                {{item | formatDate}} <span v-if="data.blok_viii.rencana_jadwal_rilis_produk_tercetak.length>1">,</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">Digital <i>(Softcopy)</i></td>
            <td colspan="3">
              <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_digital" v-bind:key="index">
                {{item | formatDate}} <span v-if="data.blok_viii.rencana_jadwal_rilis_produk_digital.length>1">,</span>
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">Datamikro</td>
            <td colspan="3">
              <span v-for="(item, index) in data.blok_viii.rencana_jadwal_rilis_produk_mikrodata" v-bind:key="index">
                {{item | formatDate}} <span v-if="data.blok_viii.rencana_jadwal_rilis_produk_mikrodata.length>1">,</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <table id="export-variabel" class="mt-4">
        <thead>
          <tr>
            <th style="min-width: 40px; text-align: center">No</th>
            <th>Nama Variabel</th>
            <th>Alias</th>
            <th style="min-width: 200px">Definisi</th>
            <th>Konsep</th>
            <th>Referensi Pemilihan</th>
            <th>Referensi Waktu</th>
            <th>Ukuran</th>
            <th>Satuan</th>
            <th>Tipe Data</th>
            <th>Klasifikasi Isian</th>
            <th style="min-width: 200px">Aturan Validasi</th>
            <th>Kalimat Pertanyaan</th>
            <th>Apakah dapat diakases umum?</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in exportedVars" :key="index">
            <td style="text-align: center">{{ index + 1 }}</td>
            <td>{{ item.nama }}</td>
            <td>{{ item.alias }}</td>
            <td>{{ item.definisi }}</td>
            <td>
              <ul class="list">
                <li v-for="(item,index) in item.konsep" :key="index">{{item}}</li>
              </ul>
            </td>
            <td>
              <ul class="list">
                <li v-for="(item,index) in item.referensi_pemilihan" :key="index">{{item}}</li>
              </ul>
            </td>
            <td>{{ item.referensi_waktu }}</td>
            <td>{{ item.ukuran }}</td>
            <td>{{ item.satuan }}</td>
            <td>{{ item.tipe_data }}</td>
            <td>
              <ul class="list">
                <li v-for="(item,index) in item.value_domain" :key="index">{{item.kode}} = {{item.nilai}}</li>
              </ul>
            </td>
            <td>
              <ul class="list">
                <li v-for="(item,index) in item.aturan_validasi" :key="index">{{item}}</li>
              </ul>
            </td>
            <td>{{ item.kalimat_pertanyaan }}</td>
            <td>
              {{ item.apakah_variabel_bisa_diakses_umum ? "Ya" : "Tidak" }}
            </td>
          </tr>
          <tr v-if="exportedVars.length==0">
            <td colspan="14">Belum ada data yang tersedia</td>
          </tr>
        </tbody>
      </table>

      <table id="export-indikator" class="mt-4">
        <thead>
          <tr>
            <th rowspan="2" style="width: 40px; text-align: center">No</th>
            <th rowspan="2" style="width: 100px">Nama Indikator</th>
            <th rowspan="2" style="width: 200px">Definisi</th>
            <th rowspan="2" style="width: 100px">Konsep</th>
            <th rowspan="2" style="width: 200px">Interpretasi</th>
            <th rowspan="2" style="width: 200px">Metode/Rumus Perhitungan</th>
            <th rowspan="2">Ukuran</th>
            <th rowspan="2">Satuan</th>
            <th rowspan="2">Klasifikasi Penyajian</th>
            <th rowspan="2">Apakah Indikator Komposit</th>
            <th colspan="2">Indikator Pembangunan</th>
            <th colspan="2">Variabel Pembangunan</th>
            <th rowspan="2">Level Estimasi</th>
            <th rowspan="2">Apakah dapat diakases umum?</th>
          </tr>
          <tr>
            <th>Nama</th>
            <th>Publikasi Ketersediaan</th>
            <th style="min-width: 300px">Nama</th>
            <th>Kegiatan Penghasil</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in exportedInds" :key="index">
          <tr style="height: 20px">
            <td :rowspan="indicatorRowspan(item)" style="min-width: 40px; text-align: center">
              {{ index + 1 }}
            </td>
            <td :rowspan="indicatorRowspan(item)">{{ item.nama }}</td>
            <td :rowspan="indicatorRowspan(item)">{{ item.definisi }}</td>
            <td :rowspan="indicatorRowspan(item)">
              <ul class="list">
                <li v-for="(item,index) in item.konsep" :key="index">{{item}}</li>
              </ul>
            </td>
            <td :rowspan="indicatorRowspan(item)">{{ item.interpretasi }}</td>
            <td :rowspan="indicatorRowspan(item)">{{ item.metode_perhitungan }}</td>
            <td :rowspan="indicatorRowspan(item)">{{ item.ukuran }}</td>
            <td :rowspan="indicatorRowspan(item)">{{ item.satuan }}</td>
            <td :rowspan="indicatorRowspan(item)">
              <ul class="list">
                <li v-for="(item,index) in item.variabel_disaggregasi" :key="index">{{item.nama}}</li>
              </ul>
            </td>
            <td :rowspan="indicatorRowspan(item)">
              {{ item.apakah_indikator_komposit ? "Ya" : "Tidak" }}
            </td>
            <!-- Indikator Pembangun -->
            
            <td style="width: 100px" :rowspan=" item.apakah_indikator_komposit ? 1 : indicatorRowspan(item)" >
              {{
                item.indikator_pembangun.length > 0 ? item.indikator_pembangun[0].nama : ""
              }}
            </td>
            <td :rowspan="item.apakah_indikator_komposit ? 1 : indicatorRowspan(item)">
              <ul class="list" v-if="item.indikator_pembangun && item.indikator_pembangun.length>0">
                <li v-for="(item,index) in item.indikator_pembangun[0].sumber_publikasi" :key="index">{{item}}</li>
              </ul>
            </td>
            <!-- Variable Pembangun -->
            
            <td style="width: 100px" :rowspan=" !item.apakah_indikator_komposit ? 1 : indicatorRowspan(item)  ">
              {{
                item.variabel_pembangun.length > 0 ? item.variabel_pembangun[0].nama : ""
              }}
            </td>
            <td  :rowspan=" !item.apakah_indikator_komposit ? 1 : indicatorRowspan(item) ">
              <ul class="list" v-if="item.variabel_pembangun && item.variabel_pembangun.length>0">
                <li v-for="(item,index) in item.variabel_pembangun[0].kegiatan_penghasil" :key="index">{{item}}</li>
              </ul>
            </td>

            <td :rowspan="indicatorRowspan(item)" style="word-break: break-all">
              {{ item.level_estimasi }}
            </td>
            <td :rowspan="indicatorRowspan(item)">
              {{ item.apakah_indikator_bisa_diakses_umum ? "Ya" : "Tidak" }}
            </td>
          </tr>
          

          <tr v-for="(row, indexRow) in indicatorRowspan(item) - 1" :key="indexRow"  :style="indexRow != indicatorRowspan(item) - 2 ? 'height:20px' : ''" >

            <td v-if="item.apakah_indikator_komposit && item.indikator_pembangun.length > indexRow + 1 " style="width: 100px" >
              {{ item.indikator_pembangun[indexRow + 1].nama }}
            </td>
            <td v-if=" item.apakah_indikator_komposit && item.indikator_pembangun.length > indexRow + 1 && item.indikator_pembangun[indexRow + 1].sumber_publikasi.length > 0">
              <ul class="list">
                <li v-for="(item,index) in item.indikator_pembangun[indexRow + 1].sumber_publikasi" :key="index">{{item}}</li>
              </ul>
            </td>
            
            <td style="width: 100px" v-if=" !item.apakah_indikator_komposit && item.variabel_pembangun.length > indexRow + 1 ">
              {{ item.variabel_pembangun[indexRow + 1].nama }}
            </td>
            <td v-if="!item.apakah_indikator_komposit && item.variabel_pembangun.length > indexRow + 1 && item.variabel_pembangun[indexRow + 1].kegiatan_penghasil.length > 0">
              <ul class="list">
                <li v-for="(item,index) in item.variabel_pembangun[indexRow + 1].kegiatan_penghasil" :key="index">{{item}}</li>
              </ul>
            </td>
            
          </tr>
         
        </tbody>
        <tbody>
           <tr v-if="exportedInds.length==0">
            <td colspan="16">Belum ada data yang tersedia</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <b-modal  hide-header hide-footer id="modal-delete" size="sm" content-class="p-0 modal modal--confirmation text-center" >
    <div class="px-2 pb-3 pt-0 mx-3 mt-0 my-2" style="border-radius:3px">
      <div >
        <img src="@/assets/img/delete.svg" width="200" height="200" />
      </div>
      <div class="text-center text-14 text-semi-bold" style="margin-top:-20px">
        Apakah anda yakin menghapus item ini?
      </div>
      <div class="text-12 text-700">
        Ketika dihapus, item tidak bisa dikembalikan lagi, kecuali anda melakukan input ulang
      </div>
      <div class="mt-4 mb-1 d-flex justify-content-center">
        <b-button class="button button--outlined mr-2" v-on:click="()=>{$bvModal.hide('modal-delete');}">Batal</b-button>
        <b-button class="button button--danger" @click="deleteMsKeg">Hapus</b-button>
      </div>
    </div>
  </b-modal>

  <b-modal hide-header hide-footer id="modal-filter" modal-class="modal modal--primary" size="lg">
    <div class="modal__header">
      <div class="modal__header__title">
        <div class="modal__header__title__name"> 
          Filter Usulan 
        </div>
        <div class="modal__header__title__description"> 
          Gunakan filter yang sesuai untuk mendapatkan hasil pencarian yang lebih baik
        </div>
      </div>
      <div class="modal__header__close">
        <button  class="button button--action" @click="$bvModal.hide('modal-filter')">
          <VueFeather type="x" size="16" stroke-width="1"></VueFeather>
        </button>
      </div>
    </div>
    <div class="modal__body">
      <div class="form">
        <b-form-group label="Jenis Statistik">
          <b-form-radio-group
            v-model="filter.statisticType"
            :options="options.statisticType"
          ></b-form-radio-group>
        </b-form-group>

        <b-form-group label="Provinsi">
          <Treeselect 
            clearable
            class="mr-2"
            placeholder="Provinsi"
            v-model="filter.provinceCode"
            :options="options.province"
            :loadOptions="loadOptions"
            :normalizer="provinceNormalizer"
            :disabled="provinceFilterDisabled"
          />
        </b-form-group>
        <b-form-group label="Kabupaten/Kota">
          <Treeselect 
            clearable
            valueFormat="object"
            placeholder="Kabupaten/Kota"
            v-model="filter.city"
            :options="options.city"
            :loadOptions="loadOptions"
            :normalizer="cityNormalizer"
            :disabled="!filter.provinceCode || cityFilterDisabled"
          />
        </b-form-group>

        <b-form-group label="Status">
          <Treeselect 
            clearable placeholder="Pilih status" 
            v-model="filter.status" :options="options.status" :disable-branch-nodes="true"
          />
        </b-form-group>
        <b-form-group label="Produsen Data">
          <Treeselect 
            clearable
            valueFormat="object"
            placeholder="Nama Produsen Data"
            v-model="filter.produsenData"
            :async="true"
            :options="options.produsenData"
            :loadOptions="produsenDataLoadOptions"
            :normalizer="produsenDataNormalizer"
            searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
          />
        </b-form-group>
        <b-form-group label="Walidata" v-if="role.isPembinaDataPusat(appData.current_role)">
          <Treeselect 
            clearable
            valueFormat="object"
            placeholder="Nama Walidata"
            v-model="filter.walidata"
            :async="true"
            :options="options.walidata"
            :loadOptions="walidataLoadOptions"
            :normalizer="produsenDataNormalizer"
            searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
          />
        </b-form-group>
      </div>
    </div>
    <div class="modal__footer">
      <div class="modal__footer__action">
        <b-button class="button button--outlined" @click="$bvModal.hide('modal-filter');">Batal</b-button>
        <b-button class="button button--primary" @click="()=>{$bvModal.hide('modal-filter');getSummaryMetadata()}">Terapkan</b-button>
      </div>
    </div>
  </b-modal>

  
  <b-modal hide-header hide-footer size="sm" id="modal-loading"  content-class="modal modal--error text-center p-2" centered dialog-class="d-flex justify-content-center">
    <div class="d-flex justify-content-start px-2 py-3">
      <img v-if="modal.isError" src="@/assets/img/error.gif" width="70" height="70" />
      <img v-else src="@/assets/img/loader.gif" width="70" height="70" />
      <div class="ml-2">
        <div :style="'font-weight:600;font-size:16px;color:'+ (modal.isError? '#d1093b':'#01ad85')" class="text-left">
          {{modal.title}}
        </div>
        <div style="font-weight:500;font-size:13px;color:#0a4e5c;" class="text-left">
          {{modal.content}}
        </div>
      </div>
    </div>
    <div class="modal__close" style="position: absolute;top: 0;right: 0;">
        <b-button v-on:click="()=>{$bvModal.hide('modal-loading');}">
          <VueFeather type="x" size="14"></VueFeather>
        </b-button>
      </div>
  </b-modal>
</div>
</template>
<script>
import MsService from "../../../services/MsService";
import SdsService from "../../../services/SdsService";
import SettingService from "@/services/SettingService";
import wilayahService from "@/services/WilayahService";
import "@/assets/scss/main.scss";
import swal from "sweetalert2";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueFeather from 'vue-feather';
import store from "../../../store";
import * as role from "../SdiRole";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import PDFMerger from "pdf-merger-js/browser";
import XLSX from "xlsx";
import moment from "moment";
// import { delay } from "lodash";
export default {
  components: {
    VueFeather,
    Treeselect
  },
  data: () => {
    return {
      isMounted:false,
      user:null,
      userRoles:[],
      currentPageMetadataStatistikKegiatan: 1,
      rowsMetadataStatistikKegiatan: 0,
      goto:0,
      perPage: 10,
      id: 0,
      dataMetadataStatistikKegiatan: [],
      initial:true,
      provinceFilterDisabled:true,
      provinceFilterVisible:false,
      cityFilterDisabled:true,
      cityFilterVisible:false,
      filter:{
        name:null,
        statisticType:null,
        status:null,
        requester:null,
        approver:null,
        produsenData:null,
        walidata:null,
        provinceCode:null,
        city:null,
      },
      tagsFilter:{
        name:null,
        statisticType:null,
        status:null,
        requester:null,
        approver:null,
        produsenData:null,
        walidata:null,
        provinceCode:null,
        city:null,
      },
      fieldsMetadata: [
        {
          key: "no",
          label: "No.",
          tdClass: "text-center",
          thStyle: { width: "5px" }
        },
        {
          key: "name",
          label: "Nama Kegiatan",
          thClass: "text-left",
          thStyle: { minWidth: "90%" }
        },
        {
          key: "tahun",
          label: "Tahun",
          thClass: "text-left",
          thStyle: { minWidth: "90%" }
        },
        {
          key: "statistic_type",
          label: "Jenis Statistik",
          thClass: 'text-left',
          tdClass: "text-left",
          thStyle: { minWidth: "130px" }
        },
        
        {
          key: "produsen_data_name",
          label: "Instansi Pengusul",
          thStyle: { minWidth: "185px" },
          thClass: 'text-left',
          tdClass: "text-left"
        },
        {
          key: "created_at",
          label: "Tanggal Dibuat",
          thStyle: { minWidth: "130px" },
          thClass: 'text-left',
          tdClass: "text-left"
        },
        {
          key: "created_by",
          label: "Pelapor",
          thStyle: { minWidth: "100px" },
          thClass: 'text-left',
          tdClass: "text-left"
        },
        {
          key: "approved_by",
          label: "Pemeriksa",
          thStyle: { minWidth: "100px" },
          thClass: 'text-left',
          tdClass: "text-left"
        },
        {
          key: "status",
          label: "Status",
          tdClass: "text-center text-nowrap"
        },
        {
          key: "aksi",
          label: "Aksi",
          thStyle: { minWidth: "100px" },
          tdClass: "text-center"
        },
      ],
      deletedId:null,
      requesters: 0,
      isLoading: true,
      divisi: null,
      idMetadataKegiatan: null,
      msKeg:null,
      exportedKeg:null,
      exportedVars:[],
      exportedInds:[],
      data:null,
      modal:{
        isError:false,
        title:"Mohon tunggu sebentar",
        content:"Proses mengambil detil kegiatan dan export sedang dilakukan",
        code:"500"
        
      },
      submissionPeriod:null,
      options:{
        submissionPeriod:[],
        statisticType: [
          {value:'STATISTIK_DASAR' , text:'Statistik Dasar', code:1},
          {value:'STATISTIK_SEKTORAL' , text:'Statistik Sektoral', code:2},
          {value:'STATISTIK_KHUSUS' , text:'Statistik Khusus', code:2},
        ],
        status:[
          {id:'DRAFT', label:'Draft'},
          {id:'SUBMITTED', label:'Submit'},
          {id:'REVIEW', label:'Diperiksa'},
          {id:'REVISED', label:'Suda Diperbaiki'},
          {id:'CORRECTION_REQUIRED', label:'Perlu Perbaikan'},
          {id:'REJECTED', label:'Ditolak'},
          {id:'APPROVED', label:'Disetujui'},
          {id:'PENDING', label:'Ditunda'},
          {id:'PUBLISHED', label:'Publish'},
        ],
        subjectField : [],
        requester:[],
        approver:[],
        organization:[],
        produsenData:[],
        walidata:[],
        masterProvince:[
          {
            id: 0,
            code: '00',
            name: "PUSAT",
          },
          {
            id: 1,
            code: '11',
            name: "ACEH"
          },
          {
            id: 2,
            code: '12',
            name: "SUMATERA UTARA"
          },
          {
            id: 3,
            code: '13',
            name: "SUMATERA BARAT"
          },
          {
            id: 4,
            code: '14',
            name: "RIAU"
          },
          {
            id: 5,
            code: '15',
            name: "JAMBI"
          },
          {
            id: 6,
            code: '16',
            name: "SUMATERA SELATAN"
          },
          {
            id: 7,
            code: '17',
            name: "BENGKULU"
          },
          {
            id: 8,
            code: '18',
            name: "LAMPUNG"
          },
          {
            id: 9,
            code: '19',
            name: "KEPULAUAN BANGKA BELITUNG"
          },
          {
            id: 10,
            code: '21',
            name: "KEPULAUAN RIAU"
          },
          {
            id: 11,
            code: '31',
            name: "DKI JAKARTA"
          },
          {
            id: 12,
            code: '32',
            name: "JAWA BARAT"
          },
          {
            id: 13,
            code: '33',
            name: "JAWA TENGAH"
          },
          {
            id: 14,
            code: '34',
            name: "DI YOGYAKARTA"
          },
          {
            id: 15,
            code: '35',
            name: "JAWA TIMUR"
          },
          {
            id: 16,
            code: '36',
            name: "BANTEN"
          },
          {
            id: 17,
            code: '51',
            name: "BALI"
          },
          {
            id: 18,
            code: '52',
            name: "NUSA TENGGARA BARAT"
          },
          {
            id: 19,
            code: '53',
            name: "NUSA TENGGARA TIMUR"
          },
          {
            id: 20,
            code: '61',
            name: "KALIMANTAN BARAT"
          },
          {
            id: 21,
            code: '62',
            name: "KALIMANTAN TENGAH"
          },
          {
            id: 22,
            code: '63',
            name: "KALIMANTAN SELATAN"
          },
          {
            id: 23,
            code: '64',
            name: "KALIMANTAN TIMUR"
          },
          {
            id: 24,
            code: '65',
            name: "KALIMANTAN UTARA"
          },
          {
            id: 25,
            code: '71',
            name: "SULAWESI UTARA"
          },
          {
            id: 26,
            code: '72',
            name: "SULAWESI TENGAH"
          },
          {
            id: 27,
            code: '73',
            name: "SULAWESI SELATAN"
          },
          {
            id: 28,
            code: '74',
            name: "SULAWESI TENGGARA"
          },
          {
            id: 29,
            code: '75',
            name: "GORONTALO"
          },
          {
            id: 30,
            code: '76',
            name: "SULAWESI BARAT"
          },
          {
            id: 31,
            code: '81',
            name: "MALUKU"
          },
          {
            id: 32,
            code: '82',
            name: "MALUKU UTARA"
          },
          {
            id: 33,
            code: '91',
            name: "PAPUA BARAT"
          },
          {
            id: 34,
            code: '94',
            name: "PAPUA"
          }
        ],
        province:[],
        city:[
          {
              id: 0,
              kode: '0000',
              nama: "PUSAT",
              provinsiId:null
          }
        ]
      }
    };
  },
  inject: ['appData'],
  async mounted() {
    this.getUserInfo(store.getters["auth/user"])
    this.setInitialFilter();
    this.setSubmissionPeriod();
    this.submissionPeriod = localStorage.getItem('msApprovalSubmissionPeriod') === null ? this.options.submissionPeriod[0].id  : localStorage.getItem('msApprovalSubmissionPeriod');

    this.getSummaryMetadata();
    this.initial = false;
    this.isMounted = true;
  },
  computed:{
    filterCount(){
      let count = 0;
      if(this.tagsFilter.status){count +=1}
      if(this.tagsFilter.statisticType){count +=1}
      if(this.tagsFilter.requester){count +=1}
      if(this.tagsFilter.produsenData ){count +=1}
      if(this.tagsFilter.walidata){count +=1}
      if(this.tagsFilter.provinceCode){count +=1}
      if(this.tagsFilter.city){count +=1}
      return count;
    },
    role(){
      return role;
    },
  },
  watch:{
    'appData.current_role'(){
      if(this.isMounted){
        this.resetFilter();
        this.getSummaryMetadata();
      }
    },
    goto(){
      if(this.goto>0){
        if(this.currentPageMetadataStatistikKegiatan != this.goto){
          this.getSummaryMetadata();
        }
        this.currentPageMetadataStatistikKegiatan = this.goto;
      }else{
        this.dataMetadataStatistikKegiatan = []
        this.rowsMetadataStatistikKegiatan = 0;
      }
    },
    currentPageMetadataStatistikKegiatan(){
      if(this.currentPageMetadataStatistikKegiatan != this.goto){
        this.getSummaryMetadata();
      }
    },
    'filter.name'(){
      this.getSummaryMetadata();
    },
    'filter.provinceCode'(){
      let provinceCode = this.filter.provinceCode;
      if(provinceCode == '00'){
        this.options.city = [{
            id: 0,
            code: '0000',
            name: "PUSAT",
            provinsiId:null
        }];
      }else{
        let prov = this.options.masterProvince.find(x=>x.code == provinceCode);
        
        this.options.city = [
          {
            id: 9999,
            code: this.user.organization.province.code+'00',
            name:"PROVINSI",
          }
        ]
        this.getKabupatenKotaList(prov.id);
      }
    },
  },
  methods: {
    async getDetailMsKeg(id) {
      await MsService.getMsKegById(id).then(
        (response)=>{
          this.msKeg = response.data.result[0];
        },
        (error)=>{
          console.log(error)
        }
      );
    },
    getUserInfo(user){
      this.user = {
        username: user.username,
        name : user.name,
        email: user.email,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      }
      this.userRoles = user.role.slice(1,-1).split(", ");
    },
    setSubmissionPeriod(){
      let currentYear = new Date().getFullYear();
      this.submissionPeriod = currentYear;
      this.options.submissionPeriod = this.range(2021, currentYear)
        
    },
    range(start, stop, step = 1){
      return Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    },
    async getSubmissionPeriod(){
      let submissionPeriods = localStorage.getItem('msSubmissionPeriods');
      if(submissionPeriods === null){
        await SettingService.getMsSettings().then(
          (result)=>{
            let settingSubmissionPeriod = result.data.body.filter(x=>x.property == 'submission_period').map(x=>x.value).sort(function(a, b){return b-a});
            this.options.submissionPeriod = settingSubmissionPeriod.map(x=>({id: parseInt(x), label:x}));
            localStorage.setItem('msSubmissionPeriods', JSON.stringify(this.options.submissionPeriod));
          },
          (error)=>{
            console.log(error)
          }
        );
      }else{
         this.options.submissionPeriod = JSON.parse(submissionPeriods);
      }

      let submissionPeriod = localStorage.getItem('msApprovalPeriod');
      if(submissionPeriod === null){
          this.submissionPeriod = this.options.submissionPeriod[0].id;
      }else{
        this.submissionPeriod = submissionPeriod;
      }
    },
    resetFilter(){
      this.filter={
        name:null,
        statisticType:null,
        status:null,
        requester:null,
        approver:null,
        produsenData:null,
        walidata:null,
        provinceCode:null,
        city:null,
      };
      this.tagsFilter={
        name:null,
        statisticType:null,
        status:null,
        requester:null,
        approver:null,
        produsenData:null,
        walidata:null,
        provinceCode:null,
        city:null,
      };
      localStorage.removeItem('msApprovalFilter');
      this.getSummaryMetadata();
    },
    setInitialFilter(){
      if(localStorage.msApprovalFilter){
        let filter = JSON.parse(localStorage.msApprovalFilter);
        
        if(filter.name){
          this.filter.name = filter.name
        }
        if(filter.status){
          this.filter.status = filter.status
        }
        if(filter.statisticType){
          this.filter.statisticType = filter.statisticType
        }
        if(filter.requester){
          this.filter.requester = filter.requester
        }
        if(filter.produsenData){
          this.filter.produsenData = filter.produsenData
        }
        if(filter.walidata){
          this.filter.walidata = filter.walidata
        }
        if(filter.provinceCode){
          this.filter.provinceCode = filter.provinceCode
        }
        if(filter.city){
          this.filter.city = filter.city
        }
      }
    },
    showModalFilter(){
      if(this.tagsFilter.statisticType == null){this.filter.submissionType = null}
      if(this.tagsFilter.status == null){this.filter.status = null}
      if(this.tagsFilter.requester == null){this.filter.requester = null}
      if(this.tagsFilter.approver == null){this.filter.approver = null}
      if(this.tagsFilter.produsenData == null){this.filter.produsenData = null}
      if(this.tagsFilter.walidata == null){this.filter.walidata = null}
      if(this.tagsFilter.provinceCode == null){this.filter.provinceCode = null}
      if(this.tagsFilter.city == null){this.filter.city = null}

      
      if(this.role.isPembinaDataPusat([this.appData.current_role])){
        this.options.province = [...this.options.masterProvince];
        this.provinceFilterDisabled = false;
        this.provinceFilterVisible = true;
        this.cityFilterDisabled = false;
        this.cityFilterVisible = true;
      }
      else if(this.role.isPembinaDataProvinsi([this.appData.current_role])){
        this.options.province = this.options.masterProvince.filter(x=>x.code == this.user.organization.province.code);
        this.provinceFilterDisabled = true;
        this.provinceFilterVisible = true;
        this.cityFilterDisabled = false;
        this.cityFilterVisible = true;
      }
      else if(this.role.isPembinaDataKabupatenKota([this.appData.current_role])){
        this.options.province = this.options.masterProvince.filter(x=>x.code == this.user.organization.province.code);
        this.provinceFilterDisabled = true;
        this.provinceFilterVisible = false;
        this.cityFilterDisabled = true;
        this.cityFilterVisible = false;
      }

      this.$bvModal.show('modal-filter');
    },
    async getSummaryMetadata() {
      this.tagsFilter={
        name:null,
        statisticType:null,
        status:null,
        requester:null,
        approver:null,
        produsenData:null,
        walidata:null,
        provinceCode:null,
        city:null,
      },
      this.isLoading = true;

      let name = this.filter.name;
      let statisticType = this.filter.statisticType;
      let status = this.filter.status;
      // let requester = this.filter.requester;
      // let approver = this.filter.approver;
      let produsenData = this.filter.produsenData;
      let walidata = this.filter.walidata;
      let provinceCode = this.filter.provinceCode;
      let city = this.filter.city;

      let page = this.currentPageMetadataStatistikKegiatan-1;
      let query = "submissionPeriod="+this.submissionPeriod+"&page="+page;
      
      if(name){
        query += "&name="+name;
        this.tagsFilter.name = name;
      }
      if(statisticType){
        query += "&statisticType="+statisticType;
        this.tagsFilter.statisticType = statisticType;
      }
      if(status){
        query += "&status="+status;
        this.tagsFilter.status = status;
      }
      if(produsenData){
        query += "&produsenDataId="+produsenData.id;
        this.tagsFilter.produsenData = produsenData;
      }
      if(walidata){
        query += "&produsenDataId="+walidata.id;
        this.tagsFilter.walidata = walidata;
      }

      
      if(provinceCode){
        query += "&produsenDataProvinceCode="+provinceCode;
        this.tagsFilter.provinceCode = provinceCode;
        
      }else{
        //provinsi kosong isikan
        //allowable for pembina data
        //1. secara default ambil yang ada di provinsinya 
        if( (!this.isMounted && role.isPembinaDataPusat([this.appData.current_role])) || !role.isPembinaDataPusat([this.appData.current_role])){
          query += "&produsenDataProvinceCode="+this.user.organization.province.code;
          this.tagsFilter.provinceCode = this.user.organization.province.code;
          this.filter.provinceCode = this.user.organization.province.code;
        }
      }
      if(role.isPembinaDataKabupatenKota([this.appData.current_role])){
        query += "&produsenDataCityCode="+this.user.organization.city.code;
        this.tagsFilter.city = this.user.organization.city; 
        this.filter.city = this.tagsFilter.city
      }
      else if(role.isPembinaDataProvinsi([this.appData.current_role])){
        if(city){
          query += "&produsenDataCityCode="+city.code
          this.tagsFilter.city = city;
        }else{
          query += "&produsenDataCityCode="+this.user.organization.province.code+'00';
          this.tagsFilter.city = {
            id: this.user.organization.province.code == '00' ? 0 :  9999,
            code: this.user.organization.province.code+'00',
            name: this.user.organization.province.code == '00' ? "PUSAT":"PROVINSI",

          }; 
          this.filter.city = this.tagsFilter.city
        }
        
      }
      else if(role.isPembinaDataPusat([this.appData.current_role])){
        if(city){
          query += "&produsenDataCityCode="+city.code;
          this.tagsFilter.city = city;
        }
      }
      this.dataMetadataStatistikKegiatan = [];
      await MsService.getMsKegList(query).then(
        response => {
          this.dataMetadataStatistikKegiatan = response.data.result[0].content;
          this.rowsMetadataStatistikKegiatan = response.data.result[0].total_elements;
          this.isLoading = false;
        },
        error => {
          console.log(error);
        }
      );
      this.goto = this.currentPageMetadataStatistikKegiatan;
      localStorage.msApprovalSubmissionPeriod = this.submissionPeriod;
      localStorage.msApprovalFilter = JSON.stringify(this.tagsFilter);
    },
    getBadge(type) {
      if (type === "DRAFT") {
        return '<span class="status status--draft">Draft</span>';
      } else if (type === "APPROVED") {
        return '<span class="status status--approved">Disetujui</span>';
      } else if (type === "REVISED") {
        return '<span class="status status--revised">Sudah Diperbaiki</span>';
      } else if (type === "REJECTED") {
        return '<span class="status status--rejected">Ditolak</span>';
      } else if (type === "UNDER_REVIEW") {
        return '<span class="status status--review">Sedang Diperiksa</span>';
      } else if (type === "CORRECTION_REQUIRED") {
        return '<span class="status status--correction">Perlu Perbaikan</span>';
      } else if (type === "SUBMITTED") {
        return '<span class="status status--submitted">Submit</span>';
      } else if (type === "PUBLISHED") {
        return '<span class="status status--published">Publish</span>';
      }
    },
    async deleteMsKeg() {
      await MsService.deleteMsKegById(this.deletedId).then(
        (result) => {
          this.$bvModal.hide('modal-delete');
          let response = result.data.result[0];
          if(response==null){
            this.getSummaryMetadata();
          }
          else{
            if(response.status == 403){
              this.modal.error.title = 'Delete Item Gagal';
              this.modal.error.description = 'Anda hanya dapat menghapus item yang berstatus DRAFT saja';
            }
            else{
              this.modal.error.title = response.title;
              this.modal.error.description = response.detail;
            }
            this.$bvModal.show('modal-error');
          }
        },
        (error) => {
            console.log(error);
        }
      );
    },
    notif(title, content, type) {
      swal.fire(title, content, type);
    },
    warningEdit() {
      this.notif(
        "Isian tidak dapat diubah",
        "Anda hanya dapat mengedit isian dengan status DRAFT dan CORRECTION_REQUIRED !",
        "warning"
      );
    },
    warningDelete() {
      this.notif(
        "Isian tidak dapat dihapus",
        "Anda hanya dapat menghapus isian dengan status DRAFT!",
        "warning"
      );
    },
    isCreatedByMe(item){
      if(item.requested_by == this.$store.getters['auth/user'].username || role.isSuperAdmin(this.userRoles)){
        return true;
      }else{
        return false;
      }
    },
    editable(item){
      if(item.status == 'DRAFT' || item.status == 'CORRECTION_REQUIRED' || role.isSuperAdmin(this.userRoles)){
        return true;
      }else{
        return false;
      }
    },
    deleteable(item){
      if(item.status == 'DRAFT'){
        return true;
      }else{
        return false;
      }
    },
    produsenDataNormalizer(node) {
      return {
        id: node.id,
        label: node.name,
      }
    },
    async produsenDataLoadOptions({searchQuery, callback}){
      let name = searchQuery;
      let page = 0;
      let provinceCode = this.filter.provinceCode;//belum tentu
      let city = this.filter.city;//belum tentu
      let cityCode = city ? city.code : null;

      if(this.role.isPembinaDataProvinsi(this.userRoles)){
        if(provinceCode==null){
          provinceCode = this.user.organization.province.code;
        }
      }

      

      await SdsService.getProdusenData(page, name, provinceCode, cityCode).then(
         (result)=>{
            let options = result.data.content;
            callback(null, options)
         },
         (error)=>{
            console.log(error)
         }
      );
    },
    async walidataLoadOptions({searchQuery, callback}){
      let name = searchQuery;
      let page = 0;
      let provinceCode = this.filter.provinceCode;
      let city = this.filter.city;
      let cityCode = null;

      if(this.role.isPembinaDataPusat(this.userRoles)){
        if(provinceCode==null){
          provinceCode = this.user.organization.province.code;
        }
        if(city==null){
          cityCode = this.user.organization.city.code;
        }else{
          cityCode = city.code;
        }
      }

      await SdsService.getWalidata(page, name, provinceCode, cityCode).then(
         (result)=>{
            let options = result.data.content;
            callback(null, options)
         },
         (error)=>{
            console.log(error)
         }
      );
    },
    async download(msKeg, type) {

      try {
        this.$bvModal.show('modal-loading');
        this.modal.isError = false;
        this.modal.title="Mohon tunggu sebentar";
        this.modal.content="Proses mengambil detil kegiatan dan export sedang dilakukan";

        this.exportedKeg = null;
        this.exportedVars = [];
        this.exportedInds = [];
        this.data = null;

        //start new script
        await this.getDetailMsKeg(msKeg.id);
        this.exportedKeg =  this.msKeg;

        if (!this.exportedKeg || !this.exportedKeg.data) {
          throw new Error("Data kegiatan tidak ditemukan");
        }

        this.data = this.exportedKeg.data;
        if(msKeg.version == 'v1'){
          this.updateMsKegV1Structure(this.exportedKeg)
        }

        // Safety check untuk ms_var
        this.exportedVars = (this.exportedKeg.ms_var || []).map(x=>{
          if(x.version == 'v1'){
            x.data = this.updateMsVarV1Structure(x.data);
          }
          return x.data;
        });

        // Safety check untuk ms_ind
        this.exportedInds = (this.exportedKeg.ms_ind || []).map(x=>{
          if(x.version == 'v1'){
            x.data = this.updateMsIndV1Structure(x.data);
          }
          return x.data;
        });

        await this.$nextTick();

        // Validasi data sebelum generate PDF/Excel
        if (type == "excel") {
          this.downloadExcel();
        } else {
          await this.downloadPdf();
        }

        this.$bvModal.hide('modal-loading');
      } catch (error) {
        this.modal.isError = true;
        this.modal.title="Error Server";
        this.modal.content="Terjadi error pada aplikasi: " + (error.message || "Unknown error") + ". Silahkan hubungi admin.",
        console.log(error)
      }
    },
    downloadExcel() {
      /* make worksheet from json */
      
      const worksheetMsKeg = "Metadata Kegiatan";
      const worksheetMsVar = "Metadata Variabel";
      const worksheetMsInd = "Metadata Indikator";
      var workbook = XLSX.utils.book_new();

      /* convert table "export-kegiatan" to worksheet named "worksheetMsKeg" */
      var msKegData = document.getElementById("export-kegiatan");
      var worksheetDataMsKeg = XLSX.utils.table_to_sheet(msKegData);

      /* convert json "exportedVars" to worksheet named "worksheetMsVar" */
      var msVarData = document.getElementById("export-variabel");
      var worksheetDataMsVar = XLSX.utils.table_to_sheet(msVarData);

      var msIndData = document.getElementById("export-indikator");
      var worksheetDataMsInd = XLSX.utils.table_to_sheet(msIndData);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetDataMsKeg,
        worksheetMsKeg
      );
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetDataMsVar,
        worksheetMsVar
      );
      XLSX.utils.book_append_sheet(
        workbook,
        worksheetDataMsInd,
        worksheetMsInd
      );
      /*create file*/
      const createdDate = moment(new Date()).format("DD_MM_YYYY");
      const fileName = "export_ms_" + createdDate + ".xlsx";
      XLSX.writeFile(workbook, fileName, { bookSST: true, type: "base64" });
    },
    async downloadPdf() {
      try {
        // Gabungkan semua (Kegiatan + Variabel + Indikator) menjadi 1 file PDF
        // exportPdfSingle sekarang async karena merge 3 PDF via pdf-merger-js
        await this.exportPdfSingle();
      } catch (error) {
        this.modal.isError = true;
        this.modal.title = "Error Generate PDF";
        this.modal.content = "Gagal membuat PDF: " + (error.message || "Unknown error");
        console.log(error);
        throw error; // propagate ke caller
      }
    },
    /**
     * Helper: bangun docDefinition untuk bagian tertentu tanpa trigger download.
     * Return: docDefinition (object yang siap di-pass ke pdfMake.createPdf)
     */
    buildDocKeg(){
      return this._buildDocKeg();
    },
    buildDocVar(){
      return this._buildDocVar();
    },
    buildDocInd(){
      return this._buildDocInd();
    },
    /**
     * Generate 1 file PDF yang berisi Kegiatan + Variabel + Indikator.
     * Setiap bagian mempertahankan orientasi & ukuran kertasnya sendiri-sendiri
     * (Keg: LEGAL portrait, Var: A3 landscape, Ind: LEGAL landscape) dengan
     * cara me-render 3 PDF terpisah lalu merge menggunakan pdf-merger-js.
     */
    async exportPdfSingle(){
      // Set vfs (font) - wajib dipanggil sebelum createPdf
      pdfMake.vfs = (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs)
        ? pdfFonts.pdfMake.vfs
        : pdfFonts;

      // Render setiap bagian ke blob
      const blobKeg = await new Promise((resolve) => {
        pdfMake.createPdf(this.buildDocKeg()).getBlob((b) => resolve(b));
      });
      const blobVar = await new Promise((resolve) => {
        pdfMake.createPdf(this.buildDocVar()).getBlob((b) => resolve(b));
      });
      const blobInd = await new Promise((resolve) => {
        pdfMake.createPdf(this.buildDocInd()).getBlob((b) => resolve(b));
      });

      // Gabungkan 3 PDF menggunakan pdf-merger-js
      const merger = new PDFMerger();
      await merger.add(blobKeg);
      await merger.add(blobVar);
      await merger.add(blobInd);

      const createdDate = moment(new Date()).format("DD_MM_YYYY");
      const fileName = "export_ms_" + createdDate + ".pdf";
      await merger.save(fileName);
    },
    /**
     * Build docDefinition untuk bagian Metadata Kegiatan.
     * Return: docDefinition object (siap untuk pdfMake.createPdf).
     */
    _buildDocKeg() {

      let keg = this.data || {};
      // Safety defaults untuk object nested
      keg.blok_i = keg.blok_i || {};
      keg.blok_i.alamat_instansi_penyelenggara = keg.blok_i.alamat_instansi_penyelenggara || {};
      keg.blok_ii = keg.blok_ii || {};
      keg.blok_ii.unit_penanggung_jawab = keg.blok_ii.unit_penanggung_jawab || {};
      keg.blok_ii.penanggung_jawab_teknis = keg.blok_ii.penanggung_jawab_teknis || {};
      keg.blok_iii = keg.blok_iii || {};
      keg.blok_iii.rencana_jadwal_kegiatan = keg.blok_iii.rencana_jadwal_kegiatan || {};
      keg.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan = keg.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan || [];
      keg.blok_iii.rencana_jadwal_kegiatan.desain = keg.blok_iii.rencana_jadwal_kegiatan.desain || [];
      keg.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data = keg.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data || [];
      keg.blok_iii.rencana_jadwal_kegiatan.pengolahan_data = keg.blok_iii.rencana_jadwal_kegiatan.pengolahan_data || [];
      keg.blok_iii.rencana_jadwal_kegiatan.analisis = keg.blok_iii.rencana_jadwal_kegiatan.analisis || [];
      keg.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil = keg.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil || [];
      keg.blok_iii.rencana_jadwal_kegiatan.evaluasi = keg.blok_iii.rencana_jadwal_kegiatan.evaluasi || [];
      keg.blok_iii.variabel_yang_dikumpulkan = keg.blok_iii.variabel_yang_dikumpulkan || [];
      keg.blok_iv = keg.blok_iv || {};
      keg.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data = keg.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data || [];
      keg.blok_iv.metode_pengumpulan_data = keg.blok_iv.metode_pengumpulan_data || {};
      keg.blok_iv.sarana_pengumpulan_data = keg.blok_iv.sarana_pengumpulan_data || {};
      keg.blok_iv.unit_pengumpulan_data = keg.blok_iv.unit_pengumpulan_data || {};
      keg.blok_v = keg.blok_v || {};
      keg.blok_vi = keg.blok_vi || {};
      keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data = keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data || {};
      keg.blok_vii = keg.blok_vii || {};
      keg.blok_vii.tahapan_pengolahan_data = keg.blok_vii.tahapan_pengolahan_data || {};
      keg.blok_vii.unit_analsis = keg.blok_vii.unit_analsis || {};
      keg.blok_vii.tingkat_penyajian_hasil_analisis = keg.blok_vii.tingkat_penyajian_hasil_analisis || {};
      keg.blok_viii = keg.blok_viii || {};
      keg.blok_viii.rencana_jadwal_rilis_produk_tercetak = keg.blok_viii.rencana_jadwal_rilis_produk_tercetak || [];
      keg.blok_viii.rencana_jadwal_rilis_produk_digital = keg.blok_viii.rencana_jadwal_rilis_produk_digital || [];
      keg.blok_viii.rencana_jadwal_rilis_produk_mikrodata = keg.blok_viii.rencana_jadwal_rilis_produk_mikrodata || [];

      // Safety check field utama
      const safe = (v) => (v === null || v === undefined ? '-' : v);
      keg.judul_kegiatan = safe(keg.judul_kegiatan);
      keg.tahun = safe(keg.tahun);
      keg.jenis_statistik = safe(keg.jenis_statistik);
      keg.cara_pengumpulan_data = safe(keg.cara_pengumpulan_data);
      keg.identitas_rekomendasi = keg.identitas_rekomendasi || null;

      let jadwal = {
        perencanaan: [],
        desain: [],
        pengumpulan: [],
        pengolahan: [],
        analisis: [],
        diseminasi: [],
        evaluasi: []
      };
      keg.blok_iii.rencana_jadwal_kegiatan.perencanaan_kegiatan.forEach(
        x => {
          jadwal.perencanaan.push(
            this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir)
          );
        }
      );
      keg.blok_iii.rencana_jadwal_kegiatan.desain.forEach(x => {
        jadwal.desain.push(
          this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir)
        );
      });
      keg.blok_iii.rencana_jadwal_kegiatan.pengumpulan_data.forEach(x => {
        jadwal.pengumpulan.push(
          this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir)
        );
      });
      keg.blok_iii.rencana_jadwal_kegiatan.pengolahan_data.forEach(x => {
        jadwal.pengolahan.push(
          this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir)
        );
      });
      keg.blok_iii.rencana_jadwal_kegiatan.analisis.forEach(x => {
        jadwal.analisis.push(
          this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir)
        );
      });
      keg.blok_iii.rencana_jadwal_kegiatan.diseminasi_hasil.forEach(x => {
        jadwal.diseminasi.push(
          this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir)
        );
      });
      keg.blok_iii.rencana_jadwal_kegiatan.evaluasi.forEach(x => {
        jadwal.evaluasi.push(
          this.dateFormatter(x.awal) + " s/d " + this.dateFormatter(x.akhir)
        );
      });
      let varsBody = [];
      varsBody.push([
        { text: "No", fillColor: "#EEEEEE" },
        { text: "Nama Variabel \n (Karakteristik", fillColor: "#EEEEEE" },
        { text: "Konsep", fillColor: "#EEEEEE" },
        { text: "Definisi", fillColor: "#EEEEEE" },
        { text: "Referensi Waktu \n (Periode Enumerasi)", fillColor: "#EEEEEE" }
      ]);
      keg.blok_iii.variabel_yang_dikumpulkan.forEach((x, index) => {
        varsBody.push([
          { text: (index + 1).toString(), alignment: "center" },
          x.nama,
          x.konsep,
          x.definisi,
          x.referensi_waktu
        ]);
      });

      let nextBody = [
        [
          { text: "IV. Desain Kegiatan", colSpan: 6, fillColor: "#EEEEEE" },"","","","",""
        ],
        [
          "4.1","Kegiatan ini dilakukan",
          { colSpan: 4 , text: this.capitalize(keg.blok_iv.kegiatan_ini_dilakukan)},"","",""
        ],
        [
          "4.2","Frekuensi Penyelenggaraan",
          {text: this.capitalize(keg.blok_iv.frekuensi_penyelanggara),colSpan: 4},"","",""
        ],
        [
          "4.3","Tipe Pengumpulan Data",
          { text: this.capitalize(keg.blok_iv.tipe_pengumpulan_data),colSpan: 4},"","",""
        ],
        [
          "4.4", "Cakupan Wilayah Pengumpulan Data",
          {text: this.capitalize(keg.blok_iv.cakupan_wilayah_pengumpulan_data ),colSpan: 4},"","",""
        ]
      ];
      if (keg.blok_iv.cakupan_wilayah_pengumpulan_data !="SELURUH_WILAYAH_INDONESIA"){
        nextBody.push(
          [
            { text: "4.5", rowSpan: keg.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data.length + 2 },{ text: "Wilayah Kegiatan", colSpan: 5 },"","","",""
          ],
          ["", "Provinsi", { text: "Kabupaten/Kota", colSpan: 4 }, "", "", ""]
        );
        keg.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data.forEach(
          wil => {
            nextBody.push([
              "", wil.nama_provinsi || wil.provinsi, { text: wil.nama_kabupaten_kota || wil.kabupaten_kota, colSpan: 4 },"","",""
            ]);
          }
        );
      }
      nextBody = nextBody.concat([
        [
          { text: "4.6", rowSpan: 6 }, { text: "Metode Pengumpulan Data", colSpan: 5 }, "", "",  "", ""
        ],
        [ "", "Wawancara", { text: keg.blok_iv.metode_pengumpulan_data.wawancara ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Mengisi kuesioner sendiri (swacacah)", { text: keg.blok_iv.metode_pengumpulan_data.mengisi_kuesioner_sendiri ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Pengamatan (observasi)", { text: keg.blok_iv.metode_pengumpulan_data.pengamatan ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Pengumpulan data sekunder", { text: keg.blok_iv.metode_pengumpulan_data.pengumpulan_data_sekunder ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Lainnya", { text: keg.blok_iv.metode_pengumpulan_data.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

        [
          { text: "4.7", rowSpan: 8 }, { text: "Sarana Pengumpulan Data", colSpan: 5 }, "", "",  "", ""
        ],
        [ "", "Paper-assisted Personal Interviewing (PAPI)", { text: keg.blok_iv.sarana_pengumpulan_data.papi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Computer-assisted Personal Interviewing (CAPI)", { text: keg.blok_iv.sarana_pengumpulan_data.capi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Computer-assisted Telephones Interviewing (CATI)", { text: keg.blok_iv.sarana_pengumpulan_data.cati ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Computer Aided Web Interviewing (CAWI)", { text: keg.blok_iv.sarana_pengumpulan_data.cawi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Mail", { text: keg.blok_iv.sarana_pengumpulan_data.mail ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Lainnya", { text: keg.blok_iv.sarana_pengumpulan_data.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

        [
          { text: "4.8", rowSpan: 5 }, { text: "Unit Pengumpulan Data", colSpan: 5 }, "", "",  "", ""
        ],
        [ "", "Individu", { text: keg.blok_iv.unit_pengumpulan_data.individu ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Rumah Tangga", { text: keg.blok_iv.unit_pengumpulan_data.rumah_tangga ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Usaha/Perusahaan", { text: keg.blok_iv.unit_pengumpulan_data.usaha_atau_perusahaan ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Lainnya", { text: keg.blok_iv.unit_pengumpulan_data.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
      ]);

      if (keg.cara_pengumpulan_data == "SURVEI") {
        nextBody = nextBody.concat([
          [{ text: "V. Desain Sampel", colSpan: 6, fillColor: "#EEEEEE" },"","","","",""],
          [
            "5.1", "Jenis Rancangan Sampel",
            {text: this.capitalize(keg.blok_v.jenis_rancangan_sampel),colSpan: 4},"","",""
          ],
          [
            "5.2", "Metode Pemilihan Sampel Tahap Terakhir",
            { text: this.capitalize(keg.blok_v.metode_pemilihan_sampel_tahap_terakhir), colSpan: 4 },"","",""
          ],
          [
            "5.3", "Metode Sampel Probabilitas yang digunakan",
            { text: this.capitalize(keg.blok_v.metode_yang_digunakan), colSpan: 4 },"","",""
          ],
          [
            "5.4", "Kerangka Sampel Tahap Terakhir",
            { text: this.capitalize(keg.blok_v.kerangka_sampel_tahap_terakhir), colSpan: 4 },"","",""
          ],
          [
            "5.5",  "Fraksi Sampel Keseluruhan",
            { text: this.capitalize(keg.blok_v.fraksi_sampel_keseluruhan), colSpan: 4 },"","",""
          ],
          [
            "5.6", "Nilai Perkiraan Sampling Error Variabel Utama",
            { text: this.capitalize(keg.blok_v.nilai_perkiraan_sampling_error_variabel_utama), colSpan: 4 },"","",""
          ],
          [
            "5.7", "Unit Sampel",
            { text: this.capitalize(keg.blok_v.unit_sampel), colSpan: 4 },"","",""
          ],
          [
            "5.8", "Unit Observasi",
            { text: this.capitalize(keg.blok_v.unit_observasi), colSpan: 4 },"","",""
          ]
        ]);
      }
      nextBody = nextBody.concat([
        [{ text: "VI. Pengumpulan Data", colSpan: 6, fillColor: "#EEEEEE" },"","","","",""],
        [
          "6.1", "Apakah Melakukan Uji Coba (Pilot Survey)?",
          { text: keg.blok_vi.apakah_melakukan_uji_coba ? "Ya" : "Tidak", colSpan: 4 },"","",""
        ],

        [
          { text: "6.2", rowSpan: 5 }, { text: "Metode Pemeriksaan Kualitas Pengumpulan Data", colSpan: 5 }, "", "", "",  ""
        ],
        [ "", "Kunjungan kembali (revisit)", { text: keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.kunjungan_kembali ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Supervisi", { text: keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.supervisi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Task Force", { text: keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.taskforce ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Lainnya", { text: keg.blok_vi.metode_pemeriksaan_kualitas_pengumpulan_data.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],

        [
          "6.3", "Apakah Melakukan Penyesuaian Nonrespon?",
          { text: keg.blok_vi.apakah_melakukan_penyesuaian_nonrespon ? "Ya" : "Tidak", colSpan: 4  }, "", "", ""
        ],

        [
          "6.4", "Petugas Pengumpulan Data",
          { text: this.capitalize(keg.blok_vi.petugas_pengumpulan_data), colSpan: 4  }, "", "", ""
        ],
        [
          "6.5", "Persyaratan Pendidikan Terendah Petugas Pengumpulan Data",
          { text: this.capitalize( keg.blok_vi.persyaratan_pendidikan_terendah_petugas_pengumpulan_data), colSpan: 4 }, "", "", ""
        ],

        [
          { text: "6.6", rowSpan: 3 }, { text: "Jumlah Petugas", colSpan: 5 }, "", "", "", ""
        ],
        [ "", "Supervisor/penyelia/pengawas", { text: keg.blok_vi.jumlah_petugas_supervisor, colSpan: 4 }, "", "", "" ],
        [ "", "Pengumpul data/enumerator", { text: keg.blok_vi.jumlah_petugas_enumerator, colSpan: 4 }, "", "", "" ],

        [
          "6.7", "Apakah Melakukan Pelatihan Petugas?",
          { text: keg.blok_vi.apakah_melakukan_pelatihan_petugas ? "Ya" : "Tidak", colSpan: 4 }, "", "", ""
        ],

        [{ text: "VII. Pengolahan dan Analisis", colSpan: 6, fillColor: "#EEEEEE" },"","","","",""],
        [
          { text: "7.1", rowSpan: 5 }, { text: "Tahapan Pengolahan Data", colSpan: 5 }, "", "",  "", ""
        ],
        [ "", "Penyuntingan (Editing)", { text: keg.blok_vii.tahapan_pengolahan_data.editing ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Penyandian (Coding)", { text: keg.blok_vii.tahapan_pengolahan_data.coding ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Data Entry", { text: keg.blok_vii.tahapan_pengolahan_data.data_entry ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Penyahihan (Validasi)", { text: keg.blok_vii.tahapan_pengolahan_data.validasi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        
        [
          "7.2", "Metode Analisis",
          { text: this.capitalize(keg.blok_vii.metode_analisis), colSpan: 4 }, "", "", ""
        ],
        [
          { text: "7.3", rowSpan: 5 }, { text: "Unit Analisis", colSpan: 5 }, "", "",  "", ""
        ],
        [ "", "Individu", { text: keg.blok_vii.unit_analsis.individu ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Rumah Tangga", { text: keg.blok_vii.unit_analsis.rumah_tangga ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Usaha/Perusahaan", { text: keg.blok_vii.unit_analsis.usaha_atau_perusahaan ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Lainnya", { text: keg.blok_vii.unit_analsis.lainnya ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
       

        [
          { text: "7.4", rowSpan: 6 }, { text: "Tingkat Penyajian Hasil Analisis", colSpan: 5 }, "", "", "", ""
        ],
        [ "", "Nasional", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.nasional ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Provinsi", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.provinsi ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Kabupaten/Kota", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.kabupaten_atau_kota ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Kecamatan", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.kecamatan ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Lainnya", { text: keg.blok_vii.tingkat_penyajian_hasil_analisis.tingkat_penyajian_hasil_analisis_lainnya, colSpan: 4 }, "", "", "" ],
        
        [{ text: "VIII. Diseminasi Hasil", colSpan: 6, fillColor: "#EEEEEE" },"","","","",""],
        [
          { text: "8.1", rowSpan: 4 }, { text: "Produk Kegiatan yang Tersedia untuk Umum", colSpan: 5 }, "", "", "", ""
        ],
        [ "", "Tercetak (Hardcopy)", { text: keg.blok_viii.ketersediaan_produk_tercetak ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Digital (Hardcopy)", { text: keg.blok_viii.ketersediaan_produk_digital ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        [ "", "Data Mikro", { text: keg.blok_viii.ketersediaan_produk_mikrodata ? "Ya" : "Tidak", colSpan: 4 }, "", "", "" ],
        

        [
          { text: "8.2", rowSpan: 4 },
          { text: "Rencana Rilis Produk Kegiatan", colSpan: 5 }, "", "", "", ""
        ],
        [
          "", "Tercetak (Hardcopy)",
          { 
            ul: keg.blok_viii.rencana_jadwal_rilis_produk_tercetak.map(x =>
              this.dateFormatter(x)
            ),
            colSpan: 4
          }, "", "", ""
        ],
        [
          "", "Digital (Hardcopy)",
          {
            ul: keg.blok_viii.rencana_jadwal_rilis_produk_digital.map(x =>
              this.dateFormatter(x)
            ), colSpan: 4
          }, "", "", ""
        ],
        [
          "", "Data Mikro",
          {
            ul: keg.blok_viii.rencana_jadwal_rilis_produk_mikrodata.map(
              x => this.dateFormatter(x)
            ), colSpan: 4
          }, "", "", ""
        ]
      ]);
      
      
      let docDefinition = {
        pageSize: "LEGAL",
        pageOrientation: "portrait",
        pageMargins: [20, 30, 20, 30],
        content: [
          {
            text: "Rekapitulasi Metadata Statistik Kegiatan",
            alignment: "center",
            style: "header"
          },
          {
            style: "tableExample",
            widths: ["auto", "auto", "auto", "auto", "auto", "*"],
            table: {
              body: [
                [
                  { text: "Judul Kegiatan",  colSpan: 3 }, "", "",
                  { text: keg.judul_kegiatan,         colSpan: 3 }, "",  ""
                ],
                [
                  { text: "Tahun",    colSpan: 3 }, "", "",
                  { text: keg.tahun,  colSpan: 3 }, "", ""
                ],
                [
                  { text: "Jenis Statistik",                    colSpan: 3 }, "",  "",
                  { text: this.capitalize(keg.jenis_statistik), colSpan: 3 },
                  "",
                  ""
                ],
                [
                  { text: "Cara Pengumpulan Data",                    colSpan: 3 }, "", "",
                  { text: this.capitalize(keg.cara_pengumpulan_data), colSpan: 3 }, "", ""
                ],
                [
                  { text: "Identitas Rekomendasi:",                                      colSpan: 3 }, "", "",
                  { text: (keg.identitas_rekomendasi ? keg.identitas_rekomendasi : '-'), colSpan: 3 }, "", ""
                ],

                [
                  { text: "I. Penyelenggara",  fillColor: "#EEEEEE", colSpan: 6 }, "", "", "", "", ""
                ],
                [
                  "1.1",  { text: "Instansi Penyelenggara", colSpan: 2 }, "",
                  { text: keg.blok_i.instansi_penyelanggara, colSpan: 3 }, "", ""
                ],
                [
                  "1.2", { text: "Alamat", colSpan: 2 }, "", 
                  { text: keg.blok_i.alamat_instansi_penyelenggara.alamat, colSpan: 3 }, "", ""
                ],
                [
                  "1.3", { text: "Telepon", colSpan: 2 }, "",
                  { text: this.capitalize(keg.blok_i.alamat_instansi_penyelenggara.telepon) , colSpan: 3 }, "", ""
                ],
                [
                  "1.4", { text: "Faksimile", colSpan: 2 }, "", 
                  { text: this.capitalize(keg.blok_i.alamat_instansi_penyelenggara.faksimile) , colSpan: 3 },"", ""
                ],
                [
                  "1.5", { text: "Email", colSpan: 2 }, "",
                  { text: this.capitalize(keg.blok_i.alamat_instansi_penyelenggara.email) , colSpan: 3 }, "", ""
                ],

                [
                  { text: "II. Penanggung Jawab", colSpan: 6,  fillColor: "#EEEEEE" },"", "", "", "", ""
                ],
                [
                  { text: "2.1", rowSpan: 3 }, { text: "Unit Eselon Penanggung Jawab", colSpan: 5 },  "", "", "",  ""
                ],
                [ 
                  "", { text: "Eselon 1", colSpan: 2 }, "", 
                  { text: keg.blok_ii.unit_penanggung_jawab.eselon1, colSpan: 3 }, "", ""
                ],
                [
                  "", { text: "Eselon 2", colSpan: 2 }, "",
                  { text: keg.blok_ii.unit_penanggung_jawab.eselon2, colSpan: 3 }, "", ""
                ],
                [
                  { text: "2.2", rowSpan: 7 }, { text: "Penanggung Jawab Teknis (setingkat Eselon 3)", colSpan: 5 }, "", "", "", ""
                ],
                [
                  "", { text: "Nama ", colSpan: 2 }, "",
                  { text: keg.blok_ii.penanggung_jawab_teknis.nama, colSpan: 3 }, "", ""
                ],
                [
                  "",  { text: "Jabatan ", colSpan: 2 }, "",
                  { text: keg.blok_ii.penanggung_jawab_teknis.jabatan, colSpan: 3 }, "", ""
                ],
                [
                  "", { text: "Alamat ", colSpan: 2 },"", 
                  { text: keg.blok_ii.penanggung_jawab_teknis.alamat, colSpan: 3 }, "", ""
                ],
                [
                  "", { text: "Telepon ", colSpan: 2 }, "",
                  { text: keg.blok_ii.penanggung_jawab_teknis.telepon, colSpan: 3 }, "", ""
                ],
                [
                  "", { text: "Faksimile ", colSpan: 2 }, "",
                  { text: keg.blok_ii.penanggung_jawab_teknis.faksimile, colSpan: 3 }, "", ""
                ],
                [
                  "", { text: "Email ", colSpan: 2 },"", 
                  { text: keg.blok_ii.penanggung_jawab_teknis.email, colSpan: 3  }, "", ""
                ],

                [
                  { text: "III. Perencanaan dan Persiapan",  colSpan: 6, fillColor: "#EEEEEE" }, "", "", "", "", ""
                ],
                [
                  "3.1", { text: "Latar Belakang Kegiatan", colSpan: 2 }, "", 
                  { text: keg.blok_iii.latar_belakang_kegiatan, colSpan: 3 }, "", ""
                ],
                [
                  "3.2", { text: "Tujuan Kegiatan ", colSpan: 2 }, "", 
                  { text: keg.blok_iii.tujuan_kegiatan, colSpan: 3 }, "", ""
                ],
                [
                  { text: "3.3", rowSpan: 12 }, { text: "Rencana Jadwal Kegiatan", colSpan: 5 }, "", "", "", ""
                ],
                ["", { text: "A. Perencanaan", colSpan: 5 }, "", "", "", ""],
                ["", "1", "Perencanaan Kegiatan",  { ul: jadwal.perencanaan, colSpan: 3 }, "", "" ],
                ["", "2", "Desain",   { ul: jadwal.desain, colSpan: 3 }, "", "" ],

                ["", { text: "B. Pengumpulan", colSpan: 5 }, "", "", "", ""],
                ["", "3",  "Pengumpulan Data", { ul: jadwal.pengumpulan, colSpan: 3 }, "", ""],


                ["", { text: "C. Pemeriksaan", colSpan: 5 }, "", "", "", ""],
                ["", "4", "Pengolahan Data", { ul: jadwal.pengolahan, colSpan: 3 }, "", ""],

                
                ["", { text: "D. Penyebarluasan", colSpan: 5 }, "", "", "", ""],
                ["", "5", "Analisis Data", { ul: jadwal.analisis, colSpan: 3 }, "", "" ],
                ["", "6", "Diseminasi Hasil", { ul: jadwal.diseminasi, colSpan: 3 }, "", "" ],
                ["", "7", "Evaluasi", { ul: jadwal.evaluasi, colSpan: 3 },  "", "" ]
              ]
            }
          },
          {
            text: "3.4. Variabel (Karakteristik) yang Dikumpulkan:",
            alignment: "left",
            style: "subheader"
          },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: [20, "auto", "auto", "auto", "auto"],
              body: varsBody
            }
          },
          {
            style: "tableExample",
            table: {
              widths: ["auto", "auto", "auto", "auto", "auto", "*"],
              body: nextBody
            }
          }
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 10,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15],
            fontSize: 9,
            color: "black",
            bold: false
          },
          tableHeader: {
            bold: false,
            fontSize: 9,
            color: "black"
          }
        },
        defaultStyle: {},
      };
      return docDefinition;
    },
    /**
     * Build docDefinition untuk bagian Metadata Variabel.
     */
    _buildDocVar() {
      let body = [];
      let column = [
        {
          text: "No",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Nama Variabel",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Alias",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Definisi",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Konsep",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Referensi Pemilihan",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Referensi Waktu",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Ukuran",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Satuan",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Tipe Data",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Klasifikasi Isian",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Aturan Validasi",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Kalimat Pertanyaan",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Apakah dapat diakses umum",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        }
      ];
      body.push(column);
      const exportedVars = this.exportedVars || [];
      exportedVars.forEach((x, index) => {
        // Safety defaults untuk mencegah error
        x.referensi_pemilihan = x.referensi_pemilihan || [];
        x.value_domain = x.value_domain || [];
        x.aturan_validasi = x.aturan_validasi || [];
        x.konsep = x.konsep || [];

        let referensi_pemilihan = [];
        x.referensi_pemilihan.forEach(ref => {
          referensi_pemilihan.push(ref.nama);
        });

        let Klasifikasi_isian = [];
        x.value_domain.forEach(val_dom => {
          Klasifikasi_isian.push(val_dom.kode + " = " + val_dom.nilai);
        });
        let aturan_validasi = [];
        // FIX: Push ke aturan_validasi, bukan referensi_pemilihan
        x.aturan_validasi.forEach(validasi => {
          aturan_validasi.push(validasi);
        });
        body.push([
          { text: (index + 1).toString(), alignment: "center" },
          x.nama || '-',
          x.alias || '-',
          x.definisi || '-',
          { ul: x.konsep },
          { ul: referensi_pemilihan },
          x.referensi_waktu || '-',
          x.ukuran ? x.ukuran : '-',
          x.satuan ? x.satuan : '-',
          x.tipe_data || '-',
          { ul: Klasifikasi_isian },
          { ul: aturan_validasi },
          x.kalimat_pertanyaan || '-',
          {
            text: x.apakah_variabel_bisa_diakses_umum ? "Ya" : "Tidak",
            alignment: "center"
          }
        ]);
      });
      let docDefinition = {
        pageSize: "A3",
        pageOrientation: "landscape",
        pageMargins: [20, 30, 20, 30],
        content: [
          {
            text: "Rekapitulasi Metadata Statistik Variabel",
            alignment: "center",
            style: "header"
          },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: [
                15,  //no
                "*", //nama
                40,  //alias
                120, //definisi
                "*", //konsep
                "*", //referensi_pemilihan
                80,  //referensi_waktu
                60,  //ukuran
                60,  //satuan
                60, //tipe_data
                100, //Klasifikasi_isian
                "*", //aturan_validasi
                100, //kalimat_pertanyaan
                30  //apakah_variabel_bisa_diakses_umum
              ],
              body: body
            }
          }
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15],
            fontSize: 9,
            color: "black",
            bold: false
          },
          tableHeader: {
            bold: false,
            fontSize: 9,
            color: "black"
          }
        },
        defaultStyle: {},
      };
      return docDefinition;
    },
    /**
     * Build docDefinition untuk bagian Metadata Indikator.
     */
    _buildDocInd() {
      let body = [];
      let firstColumn = [
        {
          text: "No",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Nama Indikator",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        
        {
          text: "Definisi",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Konsep",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Interpretasi",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Metode Perhitungan",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Ukuran",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Satuan",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Klasifikasi Penyajian",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Apakah Indikator Komposit",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Indikator Pembangun",
          style: "tableHeader",
          colSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {},
        {
          text: "Variabel Pembangun",
          style: "tableHeader",
          colSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {},
        {
          text: "Level Estimasi",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Apakah dapat diakses umum",
          style: "tableHeader",
          rowSpan: 2,
          alignment: "center",
          fillColor: "#EEEEEE"
        }
      ];
      let secondColumn = [
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {
          text: "Publikasi Ketersediaan",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Nama",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Kegiatan Penghasil",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {
          text: "Nama",
          style: "tableHeader",
          alignment: "center",
          fillColor: "#EEEEEE"
        },
        {},
        {}
      ];
      body.push(firstColumn);
      body.push(secondColumn);
      const exportedInds = this.exportedInds || [];
      exportedInds.forEach((x, index) => {
        // Safety defaults
        x.variabel_disaggregasi = x.variabel_disaggregasi || [];
        x.indikator_pembangun = x.indikator_pembangun || [];
        x.variabel_pembangun = x.variabel_pembangun || [];

        let variabel_disaggregasi = [];
        x.variabel_disaggregasi.forEach(disaggregasi => {
          if (disaggregasi && disaggregasi.nama) {
            variabel_disaggregasi.push(disaggregasi.nama);
          }
        });

        let ketersediaan_publikasi_indikator_pembangun = [];
        let nama_indikator_pembangun = [];
        let kegiatan_penghasil_variabel_pembangun = [];
        let nama_variabel_pembangun = [];
        if (x.apakah_indikator_komposit) {

          x.indikator_pembangun.forEach(ind => {
            ind.sumber_publikasi = ind.sumber_publikasi || [];
            if (ind.sumber_publikasi.length > 0) {
              ketersediaan_publikasi_indikator_pembangun.push(...ind.sumber_publikasi);
            }
          });
          x.indikator_pembangun.forEach(ind => {
            nama_indikator_pembangun.push(ind.nama || '-');
          });

        } else {

          x.variabel_pembangun.forEach(variabel => {
            variabel.kegiatan_penghasil = variabel.kegiatan_penghasil || [];
            if (variabel.kegiatan_penghasil.length > 0) {
              kegiatan_penghasil_variabel_pembangun.push(...variabel.kegiatan_penghasil);
            }
          });

          x.variabel_pembangun.forEach(variabel => {
            nama_variabel_pembangun.push(variabel.nama || '-');
          });
        }
        body.push([
          { text: (index + 1).toString(), alignment: "center" },
          x.nama || '-',
          x.konsep || '-',
          x.definisi || '-',
          x.interpretasi || '-',
          x.metode_perhitungan || '-',
          x.ukuran || '-',
          x.satuan || '-',
          variabel_disaggregasi.length>0 ? { ul: variabel_disaggregasi } : null,
          x.apakah_indikator_komposit ? "Ya" : "Tidak",
          ketersediaan_publikasi_indikator_pembangun.length>0 ? { ol: ketersediaan_publikasi_indikator_pembangun } : null,
          nama_indikator_pembangun.length>0 ? { ol: nama_indikator_pembangun } : null,
          kegiatan_penghasil_variabel_pembangun.length>0 ? { ol: kegiatan_penghasil_variabel_pembangun } : null,
          nama_variabel_pembangun.length>0 ? { ol: nama_variabel_pembangun } : null,
          x.level_estimasi || '-',
          {
            text: x.apakah_indikator_bisa_diakses_umum ? "Ya" : "Tidak",
            alignment: "center"
          }
        ]);
      });
      let docDefinition = {
        pageSize: "LEGAL",
        pageOrientation: "landscape",
        pageMargins: [20, 30, 20, 30],
        content: [
          {
            text: "Rekapitulasi Metadata Statistik Indikator",
            alignment: "center",
            style: "header"
          },
          {
            style: "tableExample",
            table: {
              headerRows: 2,
              body: body
            }
          }
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15],
            fontSize: 9,
            color: "black",
            bold: false
          },
          tableHeader: {
            bold: false,
            fontSize: 9,
            color: "black"
          }
        },
        defaultStyle: {},
      };
      return docDefinition;
    },
    indicatorRowspan(item) {
      let rowspan = [
        item.variabel_disaggregasi.length,
        item.indikator_pembangun.length,
        item.variabel_pembangun.length
      ];
      let maxRowspan = Math.max(...rowspan);
      return maxRowspan;
    },
    updateMsKegV1Structure(msKeg){
      let keg = msKeg.data;
      this.data = {
        judul_kegiatan:        keg.judulKegiatan,
        tahun:                 keg.tahun,
        jenis_statistik:       msKeg.statistic_type,
        cara_pengumpulan_data: keg.caraPengumpulanData,
        sektor_kegiatan:       keg.sektorKegiatan,
        identitas_rekomendasi: null,
        blok_i: {
          instansi_penyelanggara: keg.blokI.instansiPenyelanggara,
          alamat_instansi_penyelenggara: {
            alamat:    keg.blokI.alamatLengkapInstansiPenyelenggara,
            telepon:   keg.blokI.telepon,
            email:     keg.blokI.email,
            faksimile: keg.blokI.faksimile
          }
        },
        // blok_i: {
        //   instansi_penyelanggara: null,
        //   alamat_instansi_penyelenggara: {
        //     alamat:    null,
        //     telepon:   null,
        //     email:     null,
        //     faksimile: null
        //   }
        // },
        blok_ii: {
          unit_penanggung_jawab: {
            eselon1: keg.blokII.unitPenanggungJawabEselon1,
            eselon2: keg.blokII.unitPenanggungJawabEselon2
          },
          penanggung_jawab_teknis: {
            nama:      keg.blokII.namaPenanggungJawabTeknis,
            jabatan:   keg.blokII.jabatanPenanggungJawabTeknis,
            alamat:    keg.blokII.alamatPenanggungJawabTeknis,
            telepon:   keg.blokII.teleponPenanggungJawabTeknis,
            email:     keg.blokII.emailPenanggungJawabTeknis,
            faksimile: keg.blokII.faksimilePenanggungJawabTeknis
          }
        },
        blok_iii: {
          latar_belakang_kegiatan: keg.blokIII.latarBelakangKegiatan,
          tujuan_kegiatan:         keg.blokIII.tujuanKegiatan,
          rencana_jadwal_kegiatan: {
            perencanaan_kegiatan: keg.blokIII.rencanaJadwalKegiatan.perencanaanKegiatan.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
            desain:               keg.blokIII.rencanaJadwalKegiatan.desain.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
            pengumpulan_data:     keg.blokIII.rencanaJadwalKegiatan.pengumpulanData.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
            pengolahan_data:      keg.blokIII.rencanaJadwalKegiatan.pengolahanData.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
            analisis:             keg.blokIII.rencanaJadwalKegiatan.analisis.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
            diseminasi_hasil:     keg.blokIII.rencanaJadwalKegiatan.diseminasiHasil.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')})),
            evaluasi:             keg.blokIII.rencanaJadwalKegiatan.evaluasi.map(x=>({awal:moment(x.awal).format('YYYY-MM-DD'),akhir:moment(x.akhir).format('YYYY-MM-DD')}))
          },
          variabel_yang_dikumpulkan: keg.blokIII.variabelYangDikumpulkan.map(x=>({
            nama: x.nama,
            konsep: x.konsep,
            definisi: x.definisi,
            referensi_waktu: x.referensiWaktu
          }))
        },
        blok_iv: {
          kegiatan_ini_dilakukan:                    keg.blokIV.kegiatanIniDilakukan,
          frekuensi_penyelanggara:                   keg.blokIV.frekuensiPenyelanggara,
          tipe_pengumpulan_data:                     keg.blokIV.tipePengumpulanData,
          cakupan_wilayah_pengumpulan_data:          keg.blokIV.cakupanWilayahPengumpulanData,
          sebagian_cakupan_wilayah_pengumpulan_data: keg.blokIV.cakupanWilayahPengumpulanData == 'SEBAGIAN_WILAYAH_INDONESIA' && keg.blokIV.sebagianCakupanWilayahPengumpulanData && keg.blokIV.sebagianCakupanWilayahPengumpulanData.length>0?  
            keg.blokIV.sebagianCakupanWilayahPengumpulanData.map(x=>({
              kode_provinsi: null,
              nama_provinsi: x.provinsi,
              kode_kabupaten_kota: null,
              nama_kabupaten_kota: x.kabupatenKota
            })) : [],
          metode_pengumpulan_data: {
            wawancara:                  keg.blokIV.metodePengumpulanData.wawancara,
            mengisi_kuesioner_sendiri:  keg.blokIV.metodePengumpulanData.mengisiKuesionerSendiri,
            pengamatan:                 keg.blokIV.metodePengumpulanData.pengamatan,
            pengumpulan_data_sekunder:  keg.blokIV.metodePengumpulanData.pengumpulanDataSekunder,
            lainnya:                    keg.blokIV.metodePengumpulanData.lainnya,
            metode_pengumpulan_lainnya: keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya ? keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya : null
          },
          sarana_pengumpulan_data: {
            papi: keg.blokIV.saranaPengumpulanData.papi,
            capi: keg.blokIV.saranaPengumpulanData.capi,
            cati: keg.blokIV.saranaPengumpulanData.cati,
            cawi: keg.blokIV.saranaPengumpulanData.cawi,
            mail: keg.blokIV.saranaPengumpulanData.mail,
            lainnya: keg.blokIV.saranaPengumpulanData.lainnya,
            sarana_pengumpulan_lainnya: 
              keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya ? keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya : null, 
          },
          unit_pengumpulan_data: {
            individu:                      keg.blokIV.unitPengumpulanData.individu,
            rumah_tangga:                  keg.blokIV.unitPengumpulanData.rumahTangga,
            usaha_atau_perusahaan:         keg.blokIV.unitPengumpulanData.usahaAtauPerusahaan,
            lainnya:                       keg.blokIV.unitPengumpulanData.lainnya,
            unit_pengumpulan_data_lainnya: keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya ? keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya : null
          }
        },
        blok_v: {
          jenis_rancangan_sampel:                        keg.blokV.jenisRancanganSampel,
          metode_pemilihan_sampel_tahap_terakhir:        keg.blokV.metodePemilihanSampelTahapTerakhir,
          metode_yang_digunakan:                         keg.blokV.metodeYangdigunakan == 'MULTI_STAGE_SAMPLING' ? 'PROBABILTY_PROPORTIONAL_TO_SIZE_SAMPLING' : keg.blokV.metodePemilihanSampelTahapTerakhir,
          kerangka_sampel_tahap_terakhir:                keg.blokV.kerangkaSampelTahapTerakhir,
          fraksi_sampel_keseluruhan:                     keg.blokV.fraksiSampelKeseluruhan,
          nilai_perkiraan_sampling_error_variabel_utama: keg.blokV.nilaiPerkiraanSamplingErrorVariabelUtama,
          unit_sampel:                                   keg.blokV.unitSampel,
          unit_observasi:                                keg.blokV.unitObservasi
        },
        blok_vi: {
          apakah_melakukan_uji_coba: keg.blokVI.apakahMelakukanUjiCoba,
          metode_pemeriksaan_kualitas_pengumpulan_data: {
            kunjungan_kembali: keg.blokVI.metodePemeriksaanKualitasPengumpulanData.kunjunganKembali,
            supervisi:         keg.blokVI.metodePemeriksaanKualitasPengumpulanData.supervisi,
            taskforce:         keg.blokVI.metodePemeriksaanKualitasPengumpulanData.taskforce,
            lainnya:           keg.blokVI.metodePemeriksaanKualitasPengumpulanData.lainnya,
            metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: 
              keg.blokVI.metodePemeriksaanKualitasPengumpulanData.metodePemeriksaanKualitasPengumpulanDataLainnya ? keg.blokVI.metodePemeriksaanKualitasPengumpulanData.metodePemeriksaanKualitasPengumpulanDataLainnya : null
          },
          apakah_melakukan_penyesuaian_nonrespon:                   keg.blokVI.apakahMelakukanPenyesuaianNonrespon,
          petugas_pengumpulan_data:                                 keg.blokVI.petugasPengumpulanData,
          persyaratan_pendidikan_terendah_petugas_pengumpulan_data: keg.blokVI.persyaratanPendidikanTerendahPetugasPengumpulanData,
          jumlah_petugas_supervisor:                                keg.blokVI.jumlahPetugasSupervisor,
          jumlah_petugas_enumerator:                                keg.blokVI.jumlahPetugasEnumerator,
          apakah_melakukan_pelatihan_petugas:                       keg.blokVI.apakahMelakukanPelatihanPetugas
        },
        blok_vii: {
          tahapan_pengolahan_data: {
            editing:    keg.blokVII.tahapanPengolahanData.udi,
            coding:     keg.blokVII.tahapanPengolahanData.udi,
            data_entry: keg.blokVII.tahapanPengolahanData.udi,
            validasi:   keg.blokVII.tahapanPengolahanData.udi
          },
          metode_analisis: keg.blokVII.metodeAnalisis,
          unit_analsis: {
            individu:              keg.blokVII.unitAnalsis.individu,
            rumah_tangga:          keg.blokVII.unitAnalsis.rumahTangga,
            usaha_atau_perusahaan: keg.blokVII.unitAnalsis.usahaAtauPerusahaan,
            lainnya:               keg.blokVII.unitAnalsis.lainnya,
            unit_analisis_lainnya: keg.blokVII.unitAnalsis.unitAnalisisLainnya ? keg.blokVII.unitAnalsis.unitAnalisisLainnya : null
          },
          tingkat_penyajian_hasil_analisis: {
            nasional:            keg.blokVII.tingkatPenyajianHasilAnalisis.nasional,
            provinsi:            keg.blokVII.tingkatPenyajianHasilAnalisis.provinsi,
            kabupaten_atau_kota: keg.blokVII.tingkatPenyajianHasilAnalisis.kabupatenAtauKota,
            kecamatan:           keg.blokVII.tingkatPenyajianHasilAnalisis.kecamatan,
            lainnya:             keg.blokVII.tingkatPenyajianHasilAnalisis.lainnya,
            tingkat_penyajian_hasil_analisis_lainnya: keg.blokVII.tingkatPenyajianHasilAnalisis.tingkatPenyajianHasilAnalisisLainnya ? keg.blokVII.tingkatPenyajianHasilAnalisis.tingkatPenyajianHasilAnalisisLainnya : null, 
          }
        },
        blok_viii: {
          ketersediaan_produk_tercetak: keg.blokVIII.ketersediaanProdukTercetak,
          ketersediaan_produk_digital: keg.blokVIII.ketersediaanProdukDigital,
          ketersediaan_produk_mikrodata: keg.blokVIII.ketersediaanProdukMikrodata,
          rencana_jadwal_rilis_produk_tercetak: keg.blokVIII.ketersediaanProdukTercetak ? keg.blokVIII.rencanaJadwalRilisProdukTercetak.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
          rencana_jadwal_rilis_produk_digital: keg.blokVIII.ketersediaanProdukDigital ? keg.blokVIII.rencanaJadwalRilisProdukDigital.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
          rencana_jadwal_rilis_produk_mikrodata: keg.blokVIII.ketersediaanProdukMikrodata ? keg.blokVIII.rencanaJadwalRilisProdukMikrodata.map(x=>moment(x.tanggalRilis).format('YYYY-MM-DD')) : null,
        }
      }; 
    },
    updateMsVarV1Structure(variable){
      return  {
        nama: variable.nama ? variable.nama : null,
        alias: variable.alias ? variable.alias : null,
        konsep: Array.isArray(variable.konsep) ? variable.konsep : (variable.konsep ? [variable.konsep] : []),
        definisi: variable.definisi ? variable.definisi : null,
        referensi_pemilihan: variable.referensiPemilihan && variable.referensiPemilihan.length>0 ? variable.referensiPemilihan.map(x=>x.nama) : [],
        referensi_waktu: variable.referensiWaktu ? variable.referensiWaktu : null,
        ukuran: variable.ukuran ? variable.ukuran : null,
        satuan: variable.satuan ? variable.satuan : null,
        tipe_data: variable.tipeData ? variable.tipeData : null,
        value_domain: variable.valueDomain && variable.valueDomain.length>0 ? variable.valueDomain : [],
        aturan_validasi: variable.aturanValidasi && variable.aturanValidasi.length >0 ? variable.aturanValidasi : [],
        kalimat_pertanyaan: variable.kalimatPertanyaan ? variable.kalimatPertanyaan : null,
        apakah_variabel_bisa_diakses_umum: variable.apakahVariabelBisaDiaksesUmum ? variable.apakahVariabelBisaDiaksesUmum : null,
        id_sds: null,
      };
    },
    updateMsIndV1Structure(indikator){
      return {
        nama: indikator.nama ? indikator.nama : null,
        definisi: indikator.definisi ? indikator.definisi : null,
        konsep: indikator.konsep ? [indikator.konsep] : [],
        interpretasi: indikator.interpretasi ? indikator.interpretasi : null,
        metode_perhitungan: indikator.metodeAtauRumusPerhitungan ? indikator.metodeAtauRumusPerhitungan : null,
        rumus: null,
        ukuran: indikator.ukuran ? indikator.ukuran : null,
        satuan: indikator.satuan ? indikator.satuan : null,
        variabel_disaggregasi: indikator.variabelDisaggregasi && indikator.variabelDisaggregasi.length>0 ? indikator.variabelDisaggregasi : [null],
        apakah_indikator_komposit: indikator.apakahIndikatorKomposit ? indikator.apakahIndikatorKomposit : null,
        indikator_pembangun: indikator.indikatorPembangun && indikator.indikatorPembangun.length>0 ? indikator.indikatorPembangun.map(x=>({
            nama: x.nama,
            sumber_publikasi: x.ketersediaanPublikasi.map(x=>x.nama)
          })
        ) : [],
        variabel_pembangun: indikator.variabelPembangun && indikator.variabelPembangun.length>0 ? indikator.variabelPembangun.map(x=>({
            nama: x.nama,
            kegiatan_penghasil: x.kegiatanPenghasil
          })
        ) : [],
        level_estimasi: indikator.levelEstimasi ? indikator.levelEstimasi : null,
        apakah_indikator_bisa_diakses_umum: indikator.apakahIndikatorBisaDiaksesUmum ? indikator.apakahIndikatorBisaDiaksesUmum : null,
        id_sds: null
      };
    },
    capitalize(sentence){
      return sentence ? sentence.replaceAll('_',' ').replace(/_./g, ' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-';
    },
    dateFormatter(stringDate) {
      if (stringDate == null) {
        return "";
      } else {
        moment.locale("id");
        return moment(stringDate).format("LL");
      }
    },
    loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    provinceNormalizer(node){
      return {
         id: node.code,
         label: node.name,
      }
    },
    cityNormalizer(node){
      return {
          id: node.code,
          label: node.name,
      }
    },
    async getKabupatenKotaList(provinceId){
      wilayahService.getKabupatenKotaByIdProvinsi(provinceId).then(
         (result) => {
               let options = result.data.data.map(x=>({id:x.id, code:x.kode,name:x.nama}));
               this.options.city.push(...options);
         },
         (error) => {
               this.error=error;
         }
      );
    },
    

    approvalTooltip(item){
      if(item.requested_by == this.user.username){
        return 'Anda tidak bisa memeriksa laporan yang anda buat sendiri';
      }
      if(role.isPembinaDataPusat([this.appData.current_role])){
        if(item.produsen_data_province_code != '00'){
          return 'Anda hanya bisa memeriksa laporan yang ada di Level Pusat'
        }
      }

      if(item.status == 'DRAFT' || item.status == 'CORRECTION_REQUIRED'){
        return 'Anda hanya bisa memeriksa laporan yang berstatus selain Draft atau Perlu Perbaikan'
      }
      if(item.status == 'UNDER_REVIEW' && item.approved_by != this.user.username){
        return 'Laporan ini sedang diperiksa oleh orang lain';
      }

     return 'Periksa';
    },
    approvalDisabled(item){
      // if(item.requested_by == this.user.username){
      //   return true;
      // }
      // if(role.isPembinaDataPusat([this.appData.current_role])){
      //   if(item.produsen_data_province_code != '00'){
      //     return true
      //   }
      // }

      
      // if(item.status == 'UNDER_REVIEW' && item.approved_by != this.user.username){
      //   return true;
      // }
      if(item.status == 'DRAFT'){
        return true
      }

      return false;
    },
  },
  
};
</script>
